// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.1.8 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e9ecef; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #a0aec0; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}
	body {
    font-size: 1.05rem;
    font-family: "Poppins", sans-serif !important; 
    text-align: center;
    font-weight: 400;
    line-height: 1.5;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
/* Firefox */
* {
	scrollbar-width: thin;
	scrollbar-color: var(--blueSecondary) var(--lightPrimary);
  }
  
  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
	width: 3px;
  }
  
  *::-webkit-scrollbar-track {
	background: var(--lightPrimary);
	border-radius: 5px;
  }
  
  *::-webkit-scrollbar-thumb {
	background-color: #6e6e6e;
	border-radius: 14px;
	border: 1x solid gray;
  }
.container {
  width: 100%;
}
@media (min-width: 360x) {

  .container {
    max-width: 360x;
  }
}
@media (min-width: 480px) {

  .container {
    max-width: 480px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 992px;
  }
}
@media (min-width: 1200px) {

  .container {
    max-width: 1200px;
  }
}
@media (min-width: 1400px) {

  .container {
    max-width: 1400px;
  }
}
@media (min-width: 1600px) {

  .container {
    max-width: 1600px;
  }
}
@media (min-width: 1850px) {

  .container {
    max-width: 1850px;
  }
}


.navbar-custom .navbar-nav {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}
.my-react-select-container .my-react-select__menu {
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(17 28 68 / var(--tw-bg-opacity));
}
.dark .my-react-select-container .my-react-select__menu {
  --tw-bg-opacity: 1;
  background-color: rgb(17 28 68 / var(--tw-bg-opacity));
}
  /* .my-react-select-container {
  } */
  .my-react-select-container .my-react-select__control {
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 0.375rem;
}
  .my-react-select-container .my-react-select__control:hover {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
}
  .dark .my-react-select-container .my-react-select__control {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(17 28 68 / var(--tw-bg-opacity));
}
  .dark .my-react-select-container .my-react-select__control:hover {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
}

  .my-react-select-container .my-react-select__control--is-focused {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .my-react-select-container .my-react-select__menu {
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(17 28 68 / var(--tw-bg-opacity));
}

  .my-react-select-container .my-react-select__option {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(0 50 102 / var(--tw-text-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .my-react-select-container .my-react-select__option:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(160 174 192 / var(--tw-bg-opacity));
}

  .dark .my-react-select-container .my-react-select__option {
  --tw-bg-opacity: 1;
  background-color: rgb(17 28 68 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

  .dark .my-react-select-container .my-react-select__option:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(160 174 192 / var(--tw-bg-opacity));
}
  /* .my-react-select-container .my-react-select__option--is-focused {
    @apply bg-neutral-200 dark:bg-neutral-800;
  } */

  .my-react-select-container .my-react-select__indicator-separator {
  display: none;
  --tw-bg-opacity: 1;
  background-color: rgb(112 126 174 / var(--tw-bg-opacity));
}

  .my-react-select-container .my-react-select__input-container, 
  .my-react-select-container .my-react-select__placeholder, 
  .my-react-select-container .my-react-select__single-value {
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(0 50 102 / var(--tw-text-opacity));
}

  .dark .my-react-select-container .my-react-select__input-container, .dark 
  .my-react-select-container .my-react-select__placeholder, .dark 
  .my-react-select-container .my-react-select__single-value {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
  .error {
  position: absolute;
  bottom: -12px;
  right: 0px;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(234 6 6 / var(--tw-text-opacity));
}
  .dark .error {
  --tw-text-opacity: 1 !important;
  color: rgb(255 66 66 / var(--tw-text-opacity)) !important;
}

  ::placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(160 174 192 / var(--tw-text-opacity)) !important;
}

  .btn_sm {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(254 123 5 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

  .btn_sm:hover {
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(11 20 55 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

  .btn_sm:focus {
  right: 1rem;
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}

  .btn_sm:focus:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(202 138 4 / var(--tw-ring-opacity));
}

  .dark .btn_sm {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.navbar-custom .navbar-nav{
  flex-direction: column;
}

.navbar-custom .navbar-nav .nav-item {
  display: flex;
  align-items: center;
  --tw-border-opacity: 0.1;
  padding: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dropdown-item {
  display: block;
}
.dropdown-menu.show {
  display: block;
}
.inputfild {
  position: relative;
  margin-bottom: 0.5rem;
  display: block;
  width: 100%;
  border-radius: 5px !important;
  border-width: 1px;
  --tw-border-opacity: 1 !important;
  border-color: rgb(140 159 179 / var(--tw-border-opacity)) !important;
  background-color: rgb(255 255 255 / 0);
  padding: 0.875rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(11 20 55 / var(--tw-text-opacity));
}
.inputfild::placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(173 181 189 / var(--tw-placeholder-opacity)) !important;
}
.inputfild {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.inputfild:disabled {
  pointer-events: none !important;
  --tw-border-opacity: 1;
  border-color: rgb(197 197 197 / var(--tw-border-opacity));
  background-color: rgb(255 255 255 / 0);
  --tw-text-opacity: 1;
  color: rgb(197 197 197 / var(--tw-text-opacity));
}
.dark .inputfild {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark .inputfild:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(65 65 84 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 157 / var(--tw-text-opacity));
} 
	label {
  margin-bottom: 0.5rem;
  display: inline-block;
  font-size: 14px !important;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(11 20 55 / var(--tw-text-opacity));
} 
	label:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgb(65 65 84 / var(--tw-border-opacity)) !important;
  background-color: rgb(255 255 255 / 0);
  --tw-text-opacity: 1 !important;
  color: rgb(65 65 84 / var(--tw-text-opacity)) !important;
} 
	.dark label {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tab {
  display: flex;
  cursor: pointer;
  align-items: center;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(112 126 174 / var(--tw-border-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(112 126 174 / var(--tw-text-opacity));
}

.dark .tab {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none {
  pointer-events: none;
}

.visible {
  visibility: visible;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.right-0 {
  right: 0px;
}

.top-0 {
  top: 0px;
}

.left-0 {
  left: 0px;
}

.top-1\\/2 {
  top: 50%;
}

.bottom-0 {
  bottom: 0px;
}

.right-1 {
  right: 0.25rem;
}

.top-\\[-77px\\] {
  top: -77px;
}

.bottom-48 {
  bottom: 12rem;
}

.-left-8 {
  left: -2rem;
}

.bottom-8 {
  bottom: 2rem;
}

.-right-8 {
  right: -2rem;
}

.bottom-\\[-75px\\] {
  bottom: -75px;
}

.top-5 {
  top: 1.25rem;
}

.right-20 {
  right: 5rem;
}

.-top-24 {
  top: -6rem;
}

.-top-10 {
  top: -2.5rem;
}

.left-1\\/2 {
  left: 50%;
}

.left-full {
  left: 100%;
}

.\\!top-\\[23px\\] {
  top: 23px !important;
}

.top-11 {
  top: 2.75rem;
}

.left-3 {
  left: 0.75rem;
}

.left-\\[-3px\\] {
  left: -3px;
}

.\\!right-\\[-220px\\] {
  right: -220px !important;
}

.\\!top-\\[12px\\] {
  top: 12px !important;
}

.right-3 {
  right: 0.75rem;
}

.top-\\[70\\%\\] {
  top: 70%;
}

.z-20 {
  z-index: 20;
}

.z-10 {
  z-index: 10;
}

.z-40 {
  z-index: 40;
}

.z-50 {
  z-index: 50;
}

.col-span-3 {
  grid-column: span 3 / span 3;
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.m-auto {
  margin: auto;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mt-\\[-88px\\] {
  margin-top: -88px;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mr-4 {
  margin-right: 1rem;
}

.mr-6 {
  margin-right: 1.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.\\!mt-2 {
  margin-top: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.mt-7 {
  margin-top: 1.75rem;
}

.mt-14 {
  margin-top: 3.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

.mb-0 {
  margin-bottom: 0px;
}

.box-border {
  box-sizing: border-box;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.flex {
  display: flex;
}

.\\!flex {
  display: flex !important;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.h-full {
  height: 100%;
}

.h-\\[54px\\] {
  height: 54px;
}

.h-0 {
  height: 0px;
}

.h-8 {
  height: 2rem;
}

.h-5 {
  height: 1.25rem;
}

.h-\\[65px\\] {
  height: 65px;
}

.h-12 {
  height: 3rem;
}

.h-14 {
  height: 3.5rem;
}

.h-20 {
  height: 5rem;
}

.h-\\[480px\\] {
  height: 480px;
}

.h-9 {
  height: 2.25rem;
}

.h-10 {
  height: 2.5rem;
}

.h-screen {
  height: 100vh;
}

.h-24 {
  height: 6rem;
}

.h-\\[50px\\] {
  height: 50px;
}

.h-\\[290px\\] {
  height: 290px;
}

.max-h-full {
  max-height: 100%;
}

.max-h-40 {
  max-height: 10rem;
}

.max-h-0 {
  max-height: 0px;
}

.min-h-screen {
  min-height: 100vh;
}

.w-full {
  width: 100%;
}

.w-60p {
  width: 60%;
}

.w-\\[90\\%\\] {
  width: 90%;
}

.w-\\[80\\%\\] {
  width: 80%;
}

.w-8 {
  width: 2rem;
}

.w-5 {
  width: 1.25rem;
}

.w-20p {
  width: 20%;
}

.w-80p {
  width: 80%;
}

.w-\\[65px\\] {
  width: 65px;
}

.w-9 {
  width: 2.25rem;
}

.w-12 {
  width: 3rem;
}

.w-64 {
  width: 16rem;
}

.w-65p {
  width: 65%;
}

.w-\\[80px\\] {
  width: 80px;
}

.w-14 {
  width: 3.5rem;
}

.w-\\[70px\\] {
  width: 70px;
}

.w-70p {
  width: 70%;
}

.w-\\[120px\\] {
  width: 120px;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-10 {
  width: 2.5rem;
}

.w-52 {
  width: 13rem;
}

.w-40 {
  width: 10rem;
}

.w-36 {
  width: 9rem;
}

.w-20 {
  width: 5rem;
}

.\\!w-36 {
  width: 9rem !important;
}

.\\!w-80 {
  width: 20rem !important;
}

.\\!w-32 {
  width: 8rem !important;
}

.max-w-full {
  max-width: 100%;
}

.max-w-xl {
  max-width: 36rem;
}

.max-w-lg {
  max-width: 32rem;
}

.origin-top-right {
  transform-origin: top right;
}

.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-10 {
  --tw-translate-y: 2.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.animate-bounce {
  animation: bounce 1s infinite;
}

.cursor-pointer {
  cursor: pointer;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-items-center {
  justify-items: center;
}

.gap-8 {
  gap: 2rem;
}

.\\!gap-0 {
  gap: 0px !important;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-16 {
  gap: 4rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-28 {
  gap: 7rem;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-24 {
  gap: 6rem;
}

.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}

.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-y-scroll {
  overflow-y: scroll;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-sm {
  border-radius: 0.125rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-\\[5px\\] {
  border-radius: 5px;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-\\[6px\\] {
  border-radius: 6px;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-none {
  border-radius: 0px;
}

.rounded-\\[8px\\] {
  border-radius: 8px;
}

.border-\\[3px\\] {
  border-width: 3px;
}

.border {
  border-width: 1px;
}

.border-\\[2px\\] {
  border-width: 2px;
}

.border-t {
  border-top-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-\\[\\#d3be48\\] {
  --tw-border-opacity: 1;
  border-color: rgb(211 190 72 / var(--tw-border-opacity));
}

.border-\\[\\#75a743\\] {
  --tw-border-opacity: 1;
  border-color: rgb(117 167 67 / var(--tw-border-opacity));
}

.border-\\[\\#e4b945\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 185 69 / var(--tw-border-opacity));
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 236 239 / var(--tw-border-opacity));
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 224 / var(--tw-border-opacity));
}

.bg-\\[\\#051b34ba\\] {
  background-color: #051b34ba;
}

.bg-white\\/0 {
  background-color: rgb(255 255 255 / 0);
}

.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}

.bg-\\[\\#0b1622\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 22 34 / var(--tw-bg-opacity));
}

.\\!bg-\\[\\#e7f1dd1a\\] {
  background-color: #e7f1dd1a !important;
}

.bg-\\[\\#ffffffc4\\] {
  background-color: #ffffffc4;
}

.bg-\\[\\#468d009c\\] {
  background-color: #468d009c;
}

.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 125 / var(--tw-bg-opacity));
}

.bg-\\[\\#051b34e0\\] {
  background-color: #051b34e0;
}

.bg-\\[\\#1c55ab\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 85 171 / var(--tw-bg-opacity));
}

.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 239 / var(--tw-bg-opacity));
}

.bg-\\[\\#021a35f2\\] {
  background-color: #021a35f2;
}

.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}

.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.from-\\[\\#fe7b05\\] {
  --tw-gradient-from: #fe7b05;
  --tw-gradient-to: rgb(254 123 5 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-\\[\\#051b34c5\\] {
  --tw-gradient-from: #051b34c5;
  --tw-gradient-to: rgb(5 27 52 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-white {
  --tw-gradient-from: #ffffff;
  --tw-gradient-to: rgb(255 255 255 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-yellow-400 {
  --tw-gradient-from: #fbcf33;
  --tw-gradient-to: rgb(251 207 51 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-500 {
  --tw-gradient-from: #f97316;
  --tw-gradient-to: rgb(249 115 22 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-blue-400 {
  --tw-gradient-from: #60a5fa;
  --tw-gradient-to: rgb(96 165 250 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-navy-900 {
  --tw-gradient-from: #0b1437;
  --tw-gradient-to: rgb(11 20 55 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-gray-50 {
  --tw-gradient-from: #f8f9fa;
  --tw-gradient-to: rgb(248 249 250 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.via-gray-50 {
  --tw-gradient-to: rgb(248 249 250 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), #f8f9fa, var(--tw-gradient-to);
}

.via-yellow-400 {
  --tw-gradient-to: rgb(251 207 51 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), #fbcf33, var(--tw-gradient-to);
}

.to-\\[\\#eabb76\\] {
  --tw-gradient-to: #eabb76;
}

.to-gray-100 {
  --tw-gradient-to: #edf2f7;
}

.to-orange-500 {
  --tw-gradient-to: #f97316;
}

.to-orange-400 {
  --tw-gradient-to: #fb923c;
}

.to-blue-600 {
  --tw-gradient-to: #2152ff;
}

.to-navy-700 {
  --tw-gradient-to: #003266;
}

.to-white {
  --tw-gradient-to: #ffffff;
}

.bg-cover {
  background-size: cover;
}

.bg-clip-text {
  background-clip: text;
}

.bg-no-repeat {
  background-repeat: no-repeat;
}

.p-0 {
  padding: 0px;
}

.p-2 {
  padding: 0.5rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-8 {
  padding: 2rem;
}

.p-10 {
  padding: 2.5rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-3 {
  padding: 0.75rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.px-28 {
  padding-left: 7rem;
  padding-right: 7rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.pb-10 {
  padding-bottom: 2.5rem;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pb-3\\.5 {
  padding-bottom: 0.875rem;
}

.pl-14 {
  padding-left: 3.5rem;
}

.pr-12 {
  padding-right: 3rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pl-8 {
  padding-left: 2rem;
}

.pt-20 {
  padding-top: 5rem;
}

.pb-32 {
  padding-bottom: 8rem;
}

.pl-5 {
  padding-left: 1.25rem;
}

.pt-28 {
  padding-top: 7rem;
}

.pb-\\[420px\\] {
  padding-bottom: 420px;
}

.pt-52 {
  padding-top: 13rem;
}

.pb-20 {
  padding-bottom: 5rem;
}

.pt-40 {
  padding-top: 10rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pt-24 {
  padding-top: 6rem;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-start {
  text-align: start;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-\\[15px\\] {
  font-size: 15px;
}

.text-\\[55px\\] {
  font-size: 55px;
}

.text-\\[1\\.8rem\\] {
  font-size: 1.8rem;
}

.text-\\[17px\\] {
  font-size: 17px;
}

.\\!text-\\[22px\\] {
  font-size: 22px !important;
}

.text-\\[23px\\] {
  font-size: 23px;
}

.text-\\[14px\\] {
  font-size: 14px;
}

.text-\\[18px\\] {
  font-size: 18px;
}

.text-\\[13px\\] {
  font-size: 13px;
}

.text-\\[24px\\] {
  font-size: 24px;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-\\[20px\\] {
  font-size: 20px;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.text-\\[30px\\] {
  font-size: 30px;
}

.text-\\[38px\\] {
  font-size: 38px;
}

.font-medium {
  font-weight: 500;
}

.font-bold {
  font-weight: 700;
}

.font-semibold {
  font-weight: 600;
}

.\\!font-semibold {
  font-weight: 600 !important;
}

.font-normal {
  font-weight: 400;
}

.font-extrabold {
  font-weight: 800;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.italic {
  font-style: italic;
}

.leading-loose {
  line-height: 2;
}

.leading-\\[1\\.1\\] {
  line-height: 1.1;
}

.leading-relaxed {
  line-height: 1.625;
}

.leading-8 {
  line-height: 2rem;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.text-\\[\\#737e8c\\] {
  --tw-text-opacity: 1;
  color: rgb(115 126 140 / var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.\\!text-\\[\\#cdcdcd\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(205 205 205 / var(--tw-text-opacity)) !important;
}

.text-\\[\\#cdcdcd\\] {
  --tw-text-opacity: 1;
  color: rgb(205 205 205 / var(--tw-text-opacity));
}

.text-\\[\\#0b1622\\] {
  --tw-text-opacity: 1;
  color: rgb(11 22 34 / var(--tw-text-opacity));
}

.\\!text-\\[\\#75a743\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(117 167 67 / var(--tw-text-opacity)) !important;
}

.text-\\[\\#75a743\\] {
  --tw-text-opacity: 1;
  color: rgb(117 167 67 / var(--tw-text-opacity));
}

.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

.\\!text-\\[\\#a0acbd\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(160 172 189 / var(--tw-text-opacity)) !important;
}

.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(37 47 64 / var(--tw-text-opacity));
}

.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(163 174 208 / var(--tw-text-opacity));
}

.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(173 181 189 / var(--tw-text-opacity));
}

.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity));
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(112 126 174 / var(--tw-text-opacity));
}

.text-\\[\\#ffffff99\\] {
  color: #ffffff99;
}

.text-\\[\\#fd7701\\] {
  --tw-text-opacity: 1;
  color: rgb(253 119 1 / var(--tw-text-opacity));
}

.\\!text-\\[\\#0b1622\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(11 22 34 / var(--tw-text-opacity)) !important;
}

.text-\\[\\#6b7280\\] {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.\\!text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(112 126 174 / var(--tw-text-opacity)) !important;
}

.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}

.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(30 42 88 / var(--tw-text-opacity));
}

.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}

.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(234 6 6 / var(--tw-text-opacity));
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(160 174 192 / var(--tw-text-opacity));
}

.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

.duration-300 {
  animation-duration: 300ms;
}

.duration-500 {
  animation-duration: 500ms;
}

.ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.running {
  animation-play-state: running;
}

/* .slider {
  margin:0 20px;
  overflow:"hidden";
  padding:2rem 0;
}

.slider {
  margin: 0 20px;
  overflow: "hidden";
  padding: 1rem 0;
  height: 65px;
  display: flex;
  align-items: center;
} */

/* li.react-multi-carousel-item {
  margin-right: 21px;
} */

.slider img {
  width: 100%;
  border-radius:10px;
}

button.react-multiple-carousel__arrow {
  display: none;
}

/* .react-multi-carousel-list {
padding: 0rem 0 2rem 0;
} */

.custom-dot-list-style button{
border: none;
background: rgb(255, 68, 68);
}
.react-multi-carousel-dot.react-multi-carousel-dot--active button{
background: rgb(255, 68, 68) !important;
}
.error{
	display: inline-block;
    /* width: 197px; */
    /* white-space: nowrap; */
    overflow: hidden !important;
    text-overflow: ellipsis;
}

.i::before {
  content: "";
  position: absolute;
  width: 0px;
  height: 0px;
  opacity: 20%;
  background: white;
/*   background: #3B82F6; */
  /* Centering */
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.i:hover:before {
  animation: anim-in 0.7s forwards ease-out;
}

@keyframes anim-in {
  100% {
    opacity: 0%;
    border-radius: 0;
    width: 600px;
    height: 600px;
  }
  0% {
    width: 0px;
    height: 0px;
    border-radius: 100%;
    opacity: 20%;
  }
}


.wrapper {
  display: flex;
  justify-content: space-around;
  gap: 15px;
}
 
.container {
  width: 28vmin;
  height: 28vmin;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 1em 0;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  text-align: center;
  transition: transform 0.3s ease-in-out;
}
 
.container:hover {
  transform: scale(1.05);
}
 
.icon {
  color: red;
  font-size: 2.5em;
  text-align: center;
}
 
span.num {
  color: red;
  font-weight: 600;
  font-size: 2.5em;
}
 
span.text {
  color: #333;
  font-size: 1.2em;
  padding: 0.7em 0;
  font-weight: 600;
  text-transform: uppercase;
}
 
@media screen and (max-width: 1024px) {
  .wrapper {
    width: 90vw;
    flex-wrap: wrap;
    gap: 20px;
  }
 
}
 
@media screen and (max-width: 768px) {
  .wrapper {
    width: 90vw;
    flex-wrap: wrap;
    gap: 20px;
  }
 
  
}
 
@media screen and (max-width: 480px) {
  .wrapper {
    gap: 15px;
  }
 
  
}

.mobile-sidebar{
  display: none;
}
.navbar-custom{
  display: block;
}

/* responsive */

@media (max-width: 1191px) {
 
.Heading-01{
  font-size: 50px;
}
}

@media (max-width: 1170px) {
  .navbar-custom{
    display: none;
  }
  .mobile-sidebar{
    display: block;
  }
  ul.menu-section {
    display: none;
}
.Heading-01{
  font-size: 50px;
}
}


li {
  list-style: none;
}

@keyframes hover {
  50% {
    transform: translateX(10px);
  }
}
.offcanvas-menu > label {
  left: 30px;
  position: absolute;
  /* width: 40px;
  height: 40px; */
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  z-index: 1;
  top: 19px;
}
.offcanvas-menu label span,
.offcanvas-menu label span::before,
.offcanvas-menu label span::after {
  transition: background 0.3s, transform 0.3s;
  content: "";
  position: absolute;
  height: 2px;
  width: 20px;
  left: 13px;
  top: 18px;
  background: #b3b3b3;
}
.offcanvas-menu label span::before {
  transform: translateY(-12px);
}
.offcanvas-menu label span::after {
  transform: translateY(12px);
}
.offcanvas-menu nav {
  position: fixed;
  height: 100%;
  width: 350px;
  left: -350px;
  overflow: hidden;
  background: #001227;
  transition: 0.3s ease;
  padding: 40px 30px;
  top: 0;
  z-index: 9;
}
/* .offcanvas-menu nav > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
} */
/* .offcanvas-menu nav > div a {
  font-size: 2.5rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-family: "Monoton", cursive;
  background: linear-gradient(-90deg, #49a4ed 30%, #3d00a9 110%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.offcanvas-menu nav > div a i {
  font-size: 4rem;
  background: linear-gradient(120deg, #49a4ed 30%, #3d00a9 110%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
} */
.offcanvas-menu nav > div label {
  width: 30px;
  height: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s ease;
}
/* .offcanvas-menu nav > div label span,
.offcanvas-menu nav > div label span:before,
.offcanvas-menu nav > div label span:after {
  background: #4d4d4d;
} */
.offcanvas-menu nav > ul {
  margin-top: 30px;
  counter-reset: nav-link-count;
}
.offcanvas-menu nav > ul li {
  cursor: pointer;
  padding: 10px 0;
  transform: translateX(-30px);
  opacity: 0;
  transition: 0.4s ease;
  counter-increment: nav-link-count;
}
.offcanvas-menu nav > ul li a {
  font-size: 2.5rem;
  line-height: 1.5;
  font-weight: 400;
  color: #333333;
  display: block;
}
.offcanvas-menu nav > ul li a::after {
  content: " : " counter(nav-link-count);
}
.offcanvas-menu nav > ul li:hover {
  animation: hover 0.5s;
}
.offcanvas-menu input[type=checkbox] {
  display: none;
}
.offcanvas-menu input[type=checkbox]:checked ~ label {
  opacity: 0;
  pointer-events: none;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav {
  left: 0;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav label span {
  background: transparent;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav label span:before {
  transform: rotate(-45deg);
}
.offcanvas-menu input[type=checkbox]:checked ~ nav label span:after {
  transform: rotate(45deg);
}
.offcanvas-menu input[type=checkbox]:checked ~ nav label span:before,
.offcanvas-menu input[type=checkbox]:checked ~ nav label span:after {
  transition-delay: 0.2s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li {
  opacity: 1;
  transform: translateX(0px);
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(1) {
  transition-delay: 0.1s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(2) {
  transition-delay: 0.2s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(3) {
  transition-delay: 0.3s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(4) {
  transition-delay: 0.4s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(5) {
  transition-delay: 0.5s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(6) {
  transition-delay: 0.6s;
}
.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(7) {
  transition-delay: 0.7s;
}

 
.mobile-login .nav-item, .dropdown-item {
  line-height: normal;
  
}
.mobile-login .dropdown-menu li a{
  color: rgb(107 114 128 / var(--tw-text-opacity)) 
}

.mobile-menu  .dropdown-menu {
    position: relative;
    --tw-bg-opacity: 1;
    background: transparent;
    width: 100%;
    padding-left: 15px;
    box-shadow: none;
}
.mobile-menu  .dropdown-item {
  --tw-text-opacity: 1;
  color: #bcccef;
  padding: 0;
}
.mobile-menu .nav-item, .mobile-menu .dropdown-item {
  line-height: 3.5rem;
}
.mobile-menu .dropdown .dropdown-item {
  line-height: 3rem;
  padding: 0;
}
.mobile-menu a.nav-item.dropdown-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.mobile-menu .navbar-nav li  {
  
  text-align: left;
  /* padding: 18px 0; */
  width: 100%;
}
.mobile-menu .dropdown{
width: 100%;
}
.inner-dpd li a {
  color: #747799 !important;
}
.mobile-menu .dropdown-item:hover{
  color: #bcccef;
}
.mobile-menu .dropdown:hover>.dropdown-menu, .mobile-login .dropdown:hover>.dropdown-menu{
  display: block !important;
}
.newselect.countryselecter {
  position: absolute;
  top: 42px;
  padding: 0 10px;
 
}
.newselect.countryselecter .my-react-select__menu{
  z-index: 8;
  left: 0;
  width: 250px;
}
.newselect.countryselecter .my-react-select__control{
  position:  relative !important;
  width: auto;
}
.countryselecter .my-react-select__control {
  position: absolute;
  width: auto;
  border: none;
  white-space: nowrap;
  background: none !important;
  left: -9px;
  top: 33px;
  z-index: 2;
}

.countryselecter .my-react-select__menu{
  z-index: 8;
  left: -8px;
  top:75px;
  width: 150px;
}
.signup-phone input{
  padding-left: 106px;
}
.signup-phone.pad-left input {
    padding-left: 90px;
}
.countryselecter .my-react-select__indicators {
  padding: 2px 0px 2px 8px !important;
  position: absolute;
  right: -21px;
  top: -1px
}
.freq.newselect .countryselecter .my-react-select__control{
  left: -4px;
  top: 36px;
}
.freq.newselect .countryselecter .my-react-select__indicators{
  top: 7px;
  padding:0;
}
.invoce-country .countryselecter .my-react-select__control {
    position: absolute;
    width: auto;
    border: none;
    white-space: nowrap;
    background: none !important;
    left: 0px;
    top: 5px;
    z-index: 2;
    padding: 0;
}


input.inputfild:focus-visible {
  outline: none
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px rgba(255, 255, 255, 0) inset !important;
}

.countryselecter .my-react-select__indicators{
  display: none;
}
input.inputfild {
  font-family: "Poppins", sans-serif !important;
  font-weight: 300;
  margin-top: 15px;
  height: 46px;
  font-size: 1rem;
}
.countryselecter .my-react-select__single-value {
  font-weight: 600;
}



  
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}

.share-icon {
  border: 1px solid rgba(245, 202, 61, 0.4);
  border-radius: 1.25rem;
  cursor: pointer;
  height: 55px;
  line-height: 52px;
  text-align: center;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CircularProgressbar .CircularProgressbar-path {
  stroke: #fe7b05;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease 0s;
}

.invoce-country.frmnew .countryselecter .my-react-select__control {
 top: 2px !important
}

.slider {
  margin:0 6px;
  overflow:"hidden";
  padding:1rem 0;
}

.slider img , .slider video {
  width: 100%;
  border-radius: 4px;
} 

/* .react-multi-carousel-list {
padding: 0rem 0 2rem 0;
} */
/* .react-multi-carousel-list  button.react-multiple-carousel__arrow {
  display: block;
  z-index: 0;
} */
.react-multi-carousel-list button.react-multiple-carousel__arrow {
  background: #000;
}
.react-multi-carousel-list .react-multiple-carousel__arrow--left {
  left: calc(0% + 1px);
}
.react-multiple-carousel__arrow--right {
  right: calc(0% + 1px);
}

.custom-dot-list-style button{
border: none;
background: rgb(255, 68, 68);
}
.react-multi-carousel-dot.react-multi-carousel-dot--active button{
background: rgb(255, 68, 68) !important;
}

@media (max-width: 595px) {
  span.share-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
}
}

/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
} */


.box-border {
  border: 1px solid #f9efef;
  border-radius: 8px;
  padding: 15px;
}

.border-bot {
  border-bottom: 1px solid #f9efef;
  border-radius: 8px;

}

table {

  border-collapse: collapse;
  width: 100%;
}

td,
th {
  /* border: 1px solid #f9efef; */
  text-align: left;
  padding: 8px;
}

span.keybt {
  border: 1px solid #c9c4c4;
  padding: 2px 10px;
  border-radius: 3px;
  /* margin: 0 auto; */
  white-space: nowrap;
}

.loader-bt {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.box-dashboard-r {
  width: 100%;
  height: 100%;
  display: block;
  justify-content: center;
  align-items: center;
  position: relative;
}

.height-full {
  height: 100vh;
}

/* tr:nth-child(even) {
  background-color: #dddddd;
} */


/* .dashboard-wrapper {
  padding: 70px 45px;
} */

.copyicon {
  color: #4a5568;
  /* Equivalent to Tailwind's text-gray-800 */
  font-size: 20px;
}

.copyicon:hover {
  color: #d69e2e;
  /* Equivalent to Tailwind's text-yellow-600 */
  cursor: pointer;
}

.dark .copyicon {
  color: #ffffff;
  /* Equivalent to Tailwind's dark:text-white */
}

.tittle-name2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.no_data_available {
  width: 100%;
  height: 100%;
  display: inline-block;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* .spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  position: relative;
  top: 0;
  border: 2px solid transparent;
  border-top-color: #050708;
  border-radius: 50%;
  animation: spin 1s linear infinite;
} */

.text-danger.mt-1 {
  position: absolute;
  bottom: -26px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.table-box {
  margin-top: 75px;
}


.accordion {
  width: 100%;
  max-width: 600px;
}

.accordion-item {
  margin-bottom: 10px;
  border-radius: 6px;
  overflow: hidden;
  background: #1f1f1f;
  box-shadow: 0 0 10px #00ffd544;
}

.accordion-header {
  width: 100%;
  padding: 16px;
  font-size: 1rem;
  background: #2a2a2a;
  border: none;
  cursor: pointer;
  text-align: left;
  color: #00ffd5;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  padding: 0 16px;
  background: #1f1f1f;
  transition: max-height 0.4s ease, padding 0.3s;
}





.lightboxjs {
  margin: 0;
  padding: 0;
}

.lightboxjs * {
  box-sizing: border-box;
}

/* .lightboxjs img,
.lightboxjs svg,
.lightboxjs video {
  display: block;
  vertical-align: middle;
  height: auto;
  max-width: 100%;
} */

.slideshowBtn {
  padding-bottom: 2px;
}

.closeIcon:hover,
.closeIcon:focus,
.iconsHeader svg:hover,
.iconsHeader svg:focus,
.prev1 span:hover,
.next1:hover,
.icon:hover {
  text-decoration: none;
  cursor: pointer;
  /* color: rgb(230, 230, 230); */
}

.prevIcon:hover,
.nextIcon:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(230, 230, 230);
}

.show {
  display: flex;
}

.displayHidden {
  display: none;
}

.thumbnail {
  opacity: 1;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

.next1 {
  right: 1%;
  padding-left: 2vw;
  padding-right: 3vw;
}

.prev1 {
  left: 2%;
  padding-right: 2vw;
}

.thumbnails {
  transition: border 0.3s;
}

.thumbnail {
  display: inline;
}

.thumbnailsWithCaption {
  width: 90%;
}

.thumbnailsOuterContainer {
  position: absolute;
  bottom: 4%;
  height: 5vh;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.navigationDots {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/* Mobile screens */
@media screen and (min-width: 20em) {
  .imageSlide {
    height: 67vw;
    width: 60%;
  }

  .thumbnailsOuterContainer {
    position: absolute;
    bottom: 7%;
    width: 100vw;
    /* width: 100%; */
  }

  .thumbnailsAndCaption {
    height: 23vh;
    bottom: 2%;

  }

  .hideControlsBar .slideshowImg {
    /* height: 100vh; */
  }

  .rotateImgInnerContainer {
    top: 8%;
  }

  .hideControlsBar .slideshowInnerContainer {
    top: 0;
  }

  .thumbnail {
    width: 80px;
    max-width: 80px;
    height: 7vh;
  }

  .videoThumbnailsOuterContainer {
    bottom: 2%;
  }

  .imgTitleContainer {
    padding-bottom: 16px;
    width: 100vw;
    margin-top: 0;
    margin-bottom: 0;
  }

  .thumbnails {
    margin-left: auto;
    margin-right: auto;
  }

  .next1 {
    right: 0.9%;
  }

  .prev1 {
    left: 1.5%;
  }
}

.thumbnail {
  height: 5vh;
  border-radius: 6px;
  margin-right: 7px;
  object-fit: cover;
}



.thumbnailsOuterContainerMetadata {
  width: 78vw;
}

.videoThumbnailsOuterContainer {
  bottom: 5%;
}

.thumbnailsAndCaption {
  height: 19vh;
}

.htmlVideoOuterContainer video {
  height: 100%;
  max-height: 70vh;
  width: 100%;
}

.caption {
  position: absolute;
  bottom: 14%;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

.galleryImg {
  cursor: pointer;
  margin: 0.2em;
}

.modalContainer {
  width: 100vw;
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
}

.slideshowAnimContainer {
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000000;
}

.fullScreenContainer img {
  height: 100vh;
  max-width: 100%;
  /* max-height: 100vh; */
}

.imageInnerContainer img {
  height: 80vh;
  max-width: 100%;
  max-height: 100%;
}

.imageInnerContainer {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

.magnifyWrapper {
  margin-bottom: 3em;
  margin-left: auto;
  margin-right: auto;
}

.slideshowInnerContainer {
  position: fixed; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: top 0.2s ease-in-out 0s;
  top: 12%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

.slideshowInnerVideoContainer {
  top: 6%;
}

.slideshowInnerContainerThumbnails {
  top: 12%;
}

.hideControlsBar  {
  top: 0;
}

.fullScreenContainer {
  top: 0;
}

.lightboxContainer {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.next1,
.prev1 {
  top: calc(50% - 20px);
  position: absolute;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  padding-bottom: 2vh;
  padding-top: 2vh;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;
  width: 40px;
  height: 40px;
  font-size: 18px;
  z-index: 10000000;
}



.next1:hover,
.prev1:hover {
  color: rgb(230, 230, 230);
}

.slideshowAnimImg {
  position: absolute;
  max-width: 100vw;
}

.controls {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.iconsHeader {
  color: white;
  position: absolute;
  display: flex;
  flex-direction: row;
  /* align-items: center;
    justify-content: center; */
  cursor: pointer;
  top: 10px;
  right: 45px;
  z-index: 999999999;
  /* padding: 0.14vw; */
}

.ytVideo {
  aspect-ratio: 16 / 9;
  height: 65vh;
  width: 100%;
}

.videoOuterContainer {
  width: 65%;
  margin-left: auto;
  margin-right: auto;
  height: 60vh;
  max-height: 65vh;
}

.htmlVideoOuterContainer {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.customVideoContainer, .customEmbedContainer {
  margin-left: auto;
  margin-right: auto;
}

.videoIconsHeader {
  position: fixed;
  top: 4%;
  right: 3%;
}

.lightbox .iconsHeader svg {
  transition: 0.3s all;
}

.iconsHeader svg:active {
  transform: scale(0.97);
}

.imgTitle {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.iconsHeader svg {
  margin-left: 0.6em;
  padding: 0.2em;
  transition: all 0.1s;
  /* width: 32px;  */
  /* font-size: 18px; */
  line-height: 16px;
  vertical-align: baseline;
}

.icon {
  /* width: 32px;  */
}

@media screen and (min-width: 6em) {
  .iconsHeader {
    top: 3%;
  }

  .slideshowAnimContainer {
    width: 100vw;
  }

  .iconsHeader svg {
    /* width: 34px;  */
    padding-right: 0.3em;
  }

  .lightboxjs img {
    cursor: pointer;
  }

  .thumbnail {
    height: 9vh;
    /* width: 22vw; */
  }

  .next1 {
    top: calc(48% - 20px);
  }

  .prev1 {
    top: calc(48% - 20px);

  }


}

@media screen and (min-width: 39em) {
  .slideshowAnimContainer {
    width: 100vw;
  }

  .slideshowInnerContainer {
    /* width: 100vw;
    height: 95vh;
    position: absolute; */
  }

  .imgTitleContainer {
    padding-bottom: 0px;
  }
  

  .next1 {
    right: 0.7%;
  }

  /* .thumbnailsOuterContainer {
    bottom: 10%;
  } */

  /* .hideControlsBar .slideshow_img {
    height: 70vh;

  }

  .hideControlsBar {
    top: 10%;
  } */

  .fullScreenContainer {
    width: 100vw;
    /* height: 100vh; */
  }

  .fullScreenContainer img {
    height: 100vh;
  }

  .thumbnails {
    margin-top: 0.6em;
  }

  .thumbnail {
    /* height: 8vh; */
    width: 80px;
    max-width: 80px;
  }

  .iconsHeader svg {
    /* width: 32px; 
      font-size: 32px; */
  }

  .prev1 {
    left: 2.7%;
    padding-right: 2vw;
  }
}

/* Desktop screens */
@media screen and (min-width: 42em) {
  .imageSlide {
    height: 70vh;
    width: 80vw;
  }

  .innerContainerWithTopCaption {
    top: 8%;
  }

  .slideshowImgFullscreen {
    display: grid;
    width: 92vw;
    place-items: start;
    margin-left: auto;
    margin-right: auto;
    scrollbar-gutter: stable both-edges;
  }

  .thumbnailsAndCaption {
    bottom: 0%;
  }
  
  .rotateImgInnerContainer {
    top: 2%;
  }

  .slideshowInnerContainer img {
    margin-top: 0vh;
    /* width: 70vw; */
  }

  .fullScreenContainer img {
    width: 80vw;
  }

  .slideshowInnerContainerFullScreen {
    top: 0%;
  }

  .fullScreenLightboxImg {
    margin-left: auto;
    margin-right: auto;
    height: 100vh;
  }

  .slideshowInnerContainerImgMetadata {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .slideshowInnerContainerFullScreen {
    height: 100vh;
    width: 100vw;
    position: absolute;
  }

  .slideshowInnerContainerFullScreen img {
    object-fit: contain;
  }

  .thumbnails {
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 1.1em;
  }

  .thumbnails::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  .opacity-fade {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    opacity: 1;
  }

  .thumbnailsOuterContainer {
    margin-top: 0.1em;
    padding-top: 0.3em;
    height: 5vh;
    bottom: 11%;
  }

  .thumbnailsAndCaption {
    bottom: 0%;
  }

  .thumbnail,
  .imageSliderThumbnails img {
    height: 10vh;
    /* width: 7em; */
  }

  .slideshowAnimContainer {
    width: 100vw;
  }

  /* .slideshowInnerContainer {
    width: 100vw;
    height: 95vh;
  } */

  .hideControlsBar {
    /* height: 100vh; */
  }

  .fullScreenContainer {
    width: 100vw;
    /* height: 100vh; */
  }

  .iconsHeader svg {
    /* width: 37px;
      font-size: 34px; */
  }

  .prev1 {
    left: 2%;
    padding-right: 2vw;
  }

  .next1 {
    right: 0.4%;
  }

  
  .slideshowImgMetadata {
    width: 78vw;
  }

  .prev1Metadata {
    left: 1%;
  }

  .navigationDots {
    gap: 8px;
  }

 
}

@media screen and (min-width: 53em) {
  
  .slideshowImg {
    display: grid;
    width: 100vw;
    height: 70vh;
    place-items: start;
    /* margin-top: 7vh; */
  }

  .slideshowImgWithCaption {
    height: 68vh;
  }

  .hideControlsBar .slideshowImg, .hideControlsBarAndCaption .slideshowImg  {
    padding-top: 12vh;
  }

  .fullScreenContainer .slideshowImg {
    padding-top: 0vh;
  }


  .lightboxImg {
      /* height: 70vh; */
  }

  .thumbnail {
    width: 95px;
    max-width: 80px;
  } 

  .slideshowImgMetadata {
    width: 78vw;
  }
}
  

@media screen and (min-width: 80em) {
  .slideshowInnerContainer img {
    /* width: 60vw; */
  }

  .fullScreenContainer img {
    width: 80vw;
  }
}

.lightIcon,
.lightIcon svg {
  background-color: white;
  color: black;
}

.lightIcon:hover,
.lightIcon svg:hover {
  background-color: white;
  color: black;
  fill: black;
}

.darkIcon,
.darkIcon svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: silver;
  fill: silver;
}

.darkIcon:hover,
.darkIcon svg:hover {
  color: rgba(107, 107, 107, 0.8);
  fill: rgba(107, 107, 107, 0.8);
}

/* Header icons  */
.lightHeaderIcon svg {
  background-color: white;
  color: black;
  fill: black;
}

.lightHeaderIcon svg:hover {
  background-color: white;
  color: rgb(24, 24, 24, 0.8);
  fill: rgb(24, 24, 24, 0.8);

}

.darkHeaderIcon svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: #626b77;
  fill: #626b77;
}

.darkHeaderIcon svg:hover {
  color: rgba(99, 99, 99, 0.8);
  fill: rgba(99, 99, 99, 0.8);
}

.magnifierImage {
  object-fit: contain;
}

.thumbnails .active {
  border: solid rgb(107, 133, 206) 2px;
}

.inactiveThumbnailBorder {
  border: solid transparent 2px;
}

.thumbnails {
  width: 95%;
}

.emblaThumbs {
  --thumbs-slide-spacing: 2px; 
  /* --thumbs-slide-height: 9rem; */
  margin-top: var(--thumbs-slide-spacing);
}

@media screen and (max-width: 40em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  .imgTitleContainer {
    /* position: absolute;
    top: 12%; */
  }

  .slideshowImg {
    height: 100vh;
  }
}

@media screen and (max-width: 53em) {
  .fullScreenSlideshowImg {
    margin-top: auto;
    margin-bottom: auto;
  }
}

@media screen and (max-width: 44em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */
  .thumbnailsOuterContainer {
    bottom: 11%;
  }

  .thumbnailsAndCaption {
    bottom: 4%;
  }
  
  .imgTitleContainer {
    /* position: absolute;
    top: 5%; */
  }
}

@media screen and (max-width: 46em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  /* .imgTitleContainer {
    position: absolute;
    top: 7%;
  } */
}

@media screen and (max-width: 49em) and (min-width: 45em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  /* .imgTitleContainer {
    position: absolute;
    top: 5%;
  } */
}

@media screen and (max-width: 29em) {
  .fullScreenContainer img {
    object-fit: cover;
  }

  .emblaThumbs {
    --thumbs-slide-spacing: 3px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }



  .htmlVideo {
    margin-top: 5vh;
  }

  .thumbnails {
    width: 98%;
  }

  .thumbnail {
    width: 80px;
    max-width: 80px;
  }

  .htmlVideoOuterContainer video {
    max-height: 65vh;
  }

  .videoIconsHeader {
    position: fixed;
    top: 2%;
    right: 15px;
  }

  .videoOuterContainer {
    width: 88%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    max-height: 65vh;
  }

  .htmlVideoOuterContainer {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
  }

  .iconsHeader {
    position: fixed;
    left: 115px;
  }

  .slideshowInnerVideoContainer {
    top: 3%;
  }

  .next1,
  .prev1 {
    padding-bottom: 2vh;
    padding-top: 2vh;
  }

  .next1 {
    padding-left: 4vw;
  }

  .prev1 {
    padding-right: 4vw;
  }

  .iconsHeader {
    /* font-size: 28px; */
  }

}

@media screen and (max-width: 53em) {
  .slideshowImg {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  .slideshowImg img {
    margin-left: auto;
    margin-right: auto;
  }

  .slideshowInnerContainerFullScreen {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }

  .containImg {
    object-fit: contain;
  }
}

.fullScreenContainer img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.thumbnails {
  text-align: center;
  white-space: nowrap;
}

.reactTransformComponent {
  margin-left: auto;
  margin-right: auto;
}

.magnifierImage {
  margin-left: auto;
  margin-right: auto;
}

/* CSS loader  */
.loader {
  width: 44px;
  height: 44px;
  box-sizing: border-box;

  border-radius: 50%;

  display: inline-block;
  position: fixed;
  top: 35%;
  left: 50%;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.dayLoader {
  border: 5px solid #626b77;
  border-bottom-color: transparent;
}

.nightLoader {
  border: 5px solid #fff;
  border-bottom-color: transparent;
}

.lightboxImg {
  max-height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

.controls button, .closeButton, .closeButtonRounded {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}

.controls svg {
  box-sizing: border-box;
}

.closeButton svg, .closeButtonRounded svg {
  box-sizing: border-box;
  font-size: 16px;
  padding-top: 0.5px;
}

.closeButton {
  padding-top: 3px;
}

.closeButtonRounded {
  cursor: pointer;

}

.closeButtonRounded svg {
  margin: 0;
  padding: 5px;
  background-color: black;
  border-color: transparent;
  border-radius: 28px;

}

.thumbnailsAndCaption {
  height: 19vh;
  margin-top: 0em;
  width: 100vw;
}

.thumbnailsWithCaption {
  margin-top: 0em;
}

.slideImageAndCaption {
  top: 9%;
}

.slideImageAndCaption.hideControlsBar {
  top: 0;
}

.slideshowAnimContainer {
  -ms-overflow-style: none;
  /* scrollbar-width: none;   */
}
.thumbnails::-webkit-scrollbar {
  display: none;
}

.roundedBorder {
  border-radius: 20px;
}

.maxWidthFull {
  max-width: 100%;
}

.maxWidthWithoutMagnifier {
  max-width: 80%;
}

@media screen and (max-width: 880px) {
  .iconsHeader {
    position: fixed;
    right: 5%;
  }
}

@media screen and (max-width: 480px) {
  .iconsHeader {
    position: fixed;
    left: 180px;
  }
  
}

@media screen and (max-width: 440px) {
  .iconsHeader {
    position: fixed;
    left: 160px;
  }
}

@media screen and (max-width: 410px) {
  .iconsHeader {
    position: fixed;
    left: 140px;
  }
}

@media screen and (max-width: 385px) {
  .iconsHeader {
    position: fixed;
    left: 135px;
    /* top: 24px; */
  }
}

@media screen and (max-width: 365px) {
  .iconsHeader {
    position: fixed;
    left: 90px;
  }
}

@media screen and (max-width: 345px) {
  .iconsHeader {
    position: fixed;
    left: 82px;
  }
}

@media screen and (max-width: 325px) {
  .iconsHeader {
    position: fixed;
    left: 60px;
  }
}

@media screen and (max-width: 300px) {
  .iconsHeader {
    position: fixed;
    left: 30px;
  }
}

.lightboxVideo {
  margin-left: auto;
  margin-right: auto;
}

.navigation-wrapper {
  position: relative;
}

.dots {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

.dot {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}

.dot:focus {
  outline: none;
}

.dot.active {
  background: #000;
}

.arrow {
  position: absolute;
  top: 50%;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.2s;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: sans-serif;
}

.leftArrow {
  left: 8px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.rightArrow {
  left: auto;
  right: 8px;
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.arrow:hover {
  color: rgb(230, 230, 230);
}

.arrow--disabled,
.arrow--disabled:hover {
  color: rgba(255, 255, 255, 0.5);
}

.navDotsMargin {
  margin-top: 12px;
}

.inactiveThumbnailBorderImgSlider {
  border: 'solid transparent 2px';
}

.ytVideoImgSlider {
  width: 100%;
  height: 100%;
}

.ytVideoImgSlider iframe {
  width: 100%;
  height: 100%;
}

.outerYTVideoImgSlider {
  height: 100%;
}

.lightboxjs iframe {
  margin: none;
  padding: none;
  border: none;
}

.imgSliderArrow {
  z-index: 100000;
  background-color: transparent;
  border: none;
}

.thumbnails {
  margin-left: auto;
  margin-right: auto;
}

.cursorPointer {
  cursor: pointer;
}

.lightboxjsIcon > * { color: inherit; fill: inherit }

.embla {
  margin-left: auto;
  margin-right: auto;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-height: 19rem;
}

.emblaViewport {
  overflow: hidden;
  width: 100vw;
}

.emblaContainer {
  backface-visibility: hidden; 
  touch-action: pan-y;
  height: auto;
  margin-left: calc(var(--slide-spacing) * -1);
  display: grid;  
  grid-auto-flow: column;  
  grid-auto-columns: 100%; 
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto; 
  /* width: 80%;
*/
}

.emblaContainerImgMetadata {
  width: 78vw;
  max-width: 78vw;
  height: 80vh;
}

.imgdrag .emblaSlide {
  flex: 0 0 80%;
  min-width: 0;
  max-width: 100%;
  padding-left: 12px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

.emblaThumbsViewport {
  overflow: hidden;
}

.emblaThumbsContainer {
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
  width: 100%;
  /* align-items: center;
  text-align: center;
  width: fit-content; */
  /* justify-content: center; */
  
}

.emblaThumbsContainer::before, .emblaThumbsContainer::after {
  content: '';  /* Insert pseudo-element */
  margin: auto; /* Make it push flex items to the center */
}


.emblaThumbsSlide {
  /* min-width: 0; */
  padding-left: var(--thumbs-slide-spacing);
  /* position: relative; */
  /* width: 140px; */
}

.emblaThumbsSlideImg {
  /* display: block; */
  height: var(--thumbs-slide-height);
  width: 100%;
  object-fit: cover;
}

.mlAuto {
  margin-left: auto;
}

.metadata {
  color: white;
}

.emblaSlideGrid {
  display: flex;
}

.metadata {
  text-align: left;
  min-width: 17vw;
  max-width: 17vw;
  padding-top: 5vw;
}

.metadataPanel {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.metadataInnerContainer {
  padding-left: 7vw;
}

.metadataInnerContainer span {
  display: block;
}


.imgMetadataCloseBtn {
  position: absolute;
  top: 1%;
  right: 2%;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

/* Styling from react-zoom-pan-pinch library */
.reactTransformWrapper {
  position: relative;
  width: fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* Konqueror HTML */ /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}

.reactTransformComponent {
  display: flex;
  flex-wrap: wrap;
  width: fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}

.reactTransformComponent img {
  pointer-events: none;
}

.navigationDot {
  height: 10px;
  width: 10px;
  background-color: silver;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.navigationDotContainer {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

.imgfade.emblaContainer {
  transform: none !important; /* override Embla */
  display: flex;
  /* height: 250px; */
}

.notFullScreen {
  top: 0;
}

.imgfade.emblaSlide {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: 0; */
  left: 0 !important; /* override Embla */
  right: 0 !important; /* override Embla */
  opacity: 0;
  transition: opacity 0.5s;
  counter-increment: embla;
  border-radius: 0.5rem;
}

.imgFadeWithTopCaption {
  top: 16%;
  position: fixed;
}

.imgfade.emblaSlideSelected {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 1;
}

.imgfade.emblaSlide:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fullImg {
  height: 84vh;
  max-height: 84vh;
  object-fit: contain;
}

.rotateImg90Deg{
transform: rotate(90deg);
transition: transform 1s linear;
}  

.rotate_img {
transition: transform 0.7s linear;
}

.fullScreenContainer img {
/* max-height: 100vh; */
}

.slideshowImg img {
height: 100%;
}

.tab.react-tabs__tab--selected {
    background: #fe7b05;
    border: wheat;
    color: white;
}
.tabslist .tab {
    width: 132px;
    text-align: center;
    display: flex;
    justify-content: center;
}

:focus-visible {
  outline: none !important;
}

/* STYLE H */

.checkbox.style-h {
	display: block;
	position: relative;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	margin-bottom: 0 !important;
	
  }
  .checkbox.style-h input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
  }
  .checkbox.style-h input:checked ~ .checkbox__checkmark {
	background-color: #ca8a04 !important;
  }
  .checkbox.style-h input:checked ~ .checkbox__checkmark:after {
	opacity: 1;
	top: 0px;
  }
  .checkbox.style-h input:checked ~ .checkbox__body {
	background-position: 0 0;
	color: #fff;
  }
  .checkbox.style-h:hover input ~ .checkbox__checkmark {
	background-color: #343f6d;
  }
  .checkbox.style-h:hover input:checked ~ .checkbox__checkmark {
	background-color: #343f6d;
  }
  /* .checkbox.style-h:hover .checkbox__body {
	box-shadow: 5px 5px 10px rgba(0,0,0,0.2);
  } */
  .checkbox.style-h .checkbox__checkmark {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 15px;
	height: 20px;
	width: 20px;
	background-color: #343f6d;
	transition: background-color 0.25s ease;
	border-radius: 4px;
	/* box-shadow: inset 2px 2px 4px rgba(0,0,0,0.1), inset -2px -2px 4px rgba(255,255,255,0.4); */
  }
  .checkbox.style-h .checkbox__checkmark:after {
    content: "";
    position: absolute;
    left: 8px;
    top: -15px;
    width: 8px;
    height: 16px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: opacity 0.25s ease, top 0.25s ease;
}
  /* .checkbox.style-h .checkbox__checkmark:after {
	content: "";
	position: absolute;
	left: 10px;
	top: -15px;
	width: 10px;
	height: 20px;
	border: solid #fff;
	border-width: 0 4px 4px 0;
	transform: rotate(45deg);
	opacity: 0;
	transition: opacity 0.25s ease, top 0.25s ease;
  } */
  .checkbox.style-h .checkbox__body {
	color: #eee;
	line-height: 1.4;
	font-size: 13px;
	transition: font-weight 0.25s ease;
	font-weight: bold;
	/* color: #333; */
	/* background: linear-gradient(45deg, #08121c 0%, #08121c 50%, #08121c 50%, #0f1a25 100%); */
	background-size: 200% 100%;
	background-position: 100% 0;
	padding: 6px 15px;
	padding-left: 52px;
	border-radius: 10px;
	/* box-shadow: 2px 2px 5px rgba(0,0,0,0.2); */
	transition:  background 1s ease, color 0.25s ease;
	text-align: left;
  }
  .before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
  .before\\:bottom-0::before {
  content: var(--tw-content);
  bottom: 0px;
}
  .before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
  .before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}
  .before\\:z-0::before {
  content: var(--tw-content);
  z-index: 0;
}
  .before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}
  .before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}
  .before\\:bg-gradient-to-r::before {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
  .before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  .before\\:duration-500::before {
  transition-duration: 500ms;
  content: var(--tw-content);
  animation-duration: 500ms;
}
  .after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
  .after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}
  .after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}
  .after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}
  .after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}
  .after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
  .after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}
  .after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(203 213 224 / var(--tw-border-opacity));
}
  .after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
  .after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  .after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
  .hover\\:-translate-y-4:hover {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .hover\\:rotate-2:hover {
  --tw-rotate: 2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .hover\\:scale-x-110:hover {
  --tw-scale-x: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .hover\\:scale-y-105:hover {
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .hover\\:border-white\\/0:hover {
  border-color: rgb(255 255 255 / 0);
}
  .hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(33 82 255 / var(--tw-bg-opacity));
}
  .hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
  .hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
  .hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(163 174 208 / var(--tw-text-opacity));
}
  .hover\\:opacity-75:hover {
  opacity: 0.75;
}
  .hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .hover\\:shadow-gray-800:hover {
  --tw-shadow-color: #252f40;
  --tw-shadow: var(--tw-shadow-colored);
}
  .hover\\:before\\:left-0:hover::before {
  content: var(--tw-content);
  left: 0px;
}
  .hover\\:before\\:w-full:hover::before {
  content: var(--tw-content);
  width: 100%;
}
  .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  .focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  .focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity));
}
  .focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  @keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
  .group:hover .group-hover\\:animate-bounce {
  animation: bounce 1s infinite;
}
  .peer:checked ~ .peer-checked\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 82 255 / var(--tw-bg-opacity));
}
  .peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
  .peer:focus ~ .peer-focus\\:ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
}
  [dir="rtl"] .peer:checked ~ .rtl\\:peer-checked\\:after\\:-translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  @media (prefers-reduced-motion: no-preference) {

  @keyframes bounce {

    0%, 100% {
      transform: translateY(-25%);
      animation-timing-function: cubic-bezier(0.8,0,1,1);
    }

    50% {
      transform: none;
      animation-timing-function: cubic-bezier(0,0,0.2,1);
    }
  }

  .motion-safe\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}
  .dark .dark\\:border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(163 174 208 / var(--tw-border-opacity));
}
  .dark .dark\\:bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(112 126 174 / var(--tw-bg-opacity));
}
  .dark .dark\\:text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(163 174 208 / var(--tw-text-opacity));
}
  .dark .dark\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
  .dark .peer:focus ~ .dark\\:peer-focus\\:ring-blue-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 78 134 / var(--tw-ring-opacity));
}
  @media (min-width: 360x) {

  .xs\\:\\!hidden {
    display: none !important;
  }
}
  @media (min-width: 480px) {

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:\\!mb-0 {
    margin-bottom: 0px !important;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .sm\\:\\!text-\\[14px\\] {
    font-size: 14px !important;
  }

  .sm\\:\\!text-\\[11px\\] {
    font-size: 11px !important;
  }
}
  @media (max-width: 480px) {

  .sm-max\\:\\!top-20 {
    top: 5rem !important;
  }

  .sm-max\\:hidden {
    display: none;
  }

  .sm-max\\:\\!w-95p {
    width: 95% !important;
  }

  .sm-max\\:gap-1 {
    gap: 0.25rem;
  }

  .sm-max\\:\\!text-\\[10px\\] {
    font-size: 10px !important;
  }

  .sm-max\\:text-\\[10px\\] {
    font-size: 10px;
  }
}
  @media (min-width: 768px) {

  .md\\:m-auto {
    margin: auto;
  }

  .md\\:w-24 {
    width: 6rem;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:max-w-xl {
    max-width: 36rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:\\!text-\\[18px\\] {
    font-size: 18px !important;
  }

  .md\\:\\!text-\\[11px\\] {
    font-size: 11px !important;
  }
}
  @media (max-width: 768px) {

  .md-max\\:\\!bottom-36 {
    bottom: 9rem !important;
  }

  .md-max\\:bottom-4 {
    bottom: 1rem;
  }

  .md-max\\:\\!top-14 {
    top: 3.5rem !important;
  }

  .md-max\\:left-32 {
    left: 8rem;
  }

  .md-max\\:\\!left-\\[11px\\] {
    left: 11px !important;
  }

  .md-max\\:-left-20 {
    left: -5rem;
  }

  .md-max\\:z-20 {
    z-index: 20;
  }

  .md-max\\:mt-0 {
    margin-top: 0px;
  }

  .md-max\\:inline {
    display: inline;
  }

  .md-max\\:hidden {
    display: none;
  }

  .md-max\\:\\!h-\\[40px\\] {
    height: 40px !important;
  }

  .md-max\\:h-\\[320px\\] {
    height: 320px;
  }

  .md-max\\:w-0 {
    width: 0px;
  }

  .md-max\\:\\!w-full {
    width: 100% !important;
  }

  .md-max\\:w-full {
    width: 100%;
  }

  .md-max\\:\\!w-35p {
    width: 35% !important;
  }

  .md-max\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md-max\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md-max\\:\\!pr-0 {
    padding-right: 0px !important;
  }

  .md-max\\:\\!text-\\[12px\\] {
    font-size: 12px !important;
  }

  .md-max\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md-max\\:text-\\[13px\\] {
    font-size: 13px;
  }
}
  @media (min-width: 992px) {

  .lg\\:m-0 {
    margin: 0px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:h-12 {
    height: 3rem;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:w-12 {
    width: 3rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:max-w-2xl {
    max-width: 42rem;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-y-16 {
    row-gap: 4rem;
  }

  .lg\\:overflow-hidden {
    overflow: hidden;
  }

  .lg\\:overflow-visible {
    overflow: visible;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:\\!text-\\[22px\\] {
    font-size: 22px !important;
  }

  .lg\\:\\!text-\\[12px\\] {
    font-size: 12px !important;
  }

  .lg\\:text-\\[35px\\] {
    font-size: 35px;
  }
}
  @media (max-width: 992px) {

  .lg-max\\:-left-0 {
    left: -0px;
  }

  .lg-max\\:right-0 {
    right: 0px;
  }

  .lg-max\\:order-last {
    order: 9999;
  }

  .lg-max\\:\\!mt-5 {
    margin-top: 1.25rem !important;
  }

  .lg-max\\:mt-3 {
    margin-top: 0.75rem;
  }

  .lg-max\\:inline-block {
    display: inline-block;
  }

  .lg-max\\:flex {
    display: flex;
  }

  .lg-max\\:hidden {
    display: none;
  }

  .lg-max\\:h-12 {
    height: 3rem;
  }

  .lg-max\\:w-90p {
    width: 90%;
  }

  .lg-max\\:w-full {
    width: 100%;
  }

  .lg-max\\:w-20 {
    width: 5rem;
  }

  .lg-max\\:w-56 {
    width: 14rem;
  }

  .lg-max\\:\\!justify-center {
    justify-content: center !important;
  }

  .lg-max\\:\\!gap-2 {
    gap: 0.5rem !important;
  }

  .lg-max\\:bg-\\[\\#001227\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 18 39 / var(--tw-bg-opacity));
  }

  .lg-max\\:pt-\\[78px\\] {
    padding-top: 78px;
  }

  .lg-max\\:pl-\\[73px\\] {
    padding-left: 73px;
  }

  .lg-max\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .lg-max\\:text-center {
    text-align: center;
  }

  .lg-max\\:\\!text-\\[12px\\] {
    font-size: 12px !important;
  }

  .lg-max\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .lg-max\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
  @media (min-width: 1200px) {

  .xl\\:absolute {
    position: absolute;
  }

  .xl\\:w-60p {
    width: 60%;
  }

  .xl\\:max-w-xl {
    max-width: 36rem;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:gap-16 {
    gap: 4rem;
  }

  .xl\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .xl\\:\\!text-\\[25px\\] {
    font-size: 25px !important;
  }

  .xl\\:\\!text-\\[14px\\] {
    font-size: 14px !important;
  }
}
  @media (max-width: 1200px) {

  .xl-max\\:top-7 {
    top: 1.75rem;
  }

  .xl-max\\:right-6 {
    right: 1.5rem;
  }

  .xl-max\\:order-last {
    order: 9999;
  }

  .xl-max\\:col-span-full {
    grid-column: 1 / -1;
  }

  .xl-max\\:mt-5 {
    margin-top: 1.25rem;
  }

  .xl-max\\:mt-8 {
    margin-top: 2rem;
  }

  .xl-max\\:mt-0 {
    margin-top: 0px;
  }

  .xl-max\\:mb-8 {
    margin-bottom: 2rem;
  }

  .xl-max\\:mt-10 {
    margin-top: 2.5rem;
  }

  .xl-max\\:\\!mt-5 {
    margin-top: 1.25rem !important;
  }

  .xl-max\\:mt-6 {
    margin-top: 1.5rem;
  }

  .xl-max\\:w-88p {
    width: 88%;
  }

  .xl-max\\:w-full {
    width: 100%;
  }

  .xl-max\\:w-95p {
    width: 95%;
  }

  .xl-max\\:w-60p {
    width: 60%;
  }

  .xl-max\\:w-47p {
    width: 47%;
  }

  .xl-max\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl-max\\:\\!justify-end {
    justify-content: flex-end !important;
  }

  .xl-max\\:\\!gap-0 {
    gap: 0px !important;
  }

  .xl-max\\:gap-6 {
    gap: 1.5rem;
  }

  .xl-max\\:gap-0 {
    gap: 0px;
  }

  .xl-max\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .xl-max\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .xl-max\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl-max\\:pt-0 {
    padding-top: 0px;
  }

  .xl-max\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .xl-max\\:pb-\\[65px\\] {
    padding-bottom: 65px;
  }

  .xl-max\\:pt-12 {
    padding-top: 3rem;
  }
}
  @media (min-width: 1400px) {

  .\\32xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .\\32xl\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\32xl\\:\\!text-\\[30px\\] {
    font-size: 30px !important;
  }

  .\\32xl\\:\\!text-\\[16px\\] {
    font-size: 16px !important;
  }
}
  @media (max-width: 1400px) {

  .\\32xl-max\\:\\!justify-end {
    justify-content: flex-end !important;
  }

  .\\32xl-max\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
  @media (min-width: 1600px) {

  .\\33xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .\\33xl\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;CAAd;IAAA,kBAAc;IAAd,6CAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,gBAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;AACd,YAAY;AACZ;CACC,qBAAqB;CACrB,yDAAyD;EACxD;;EAEA,6BAA6B;EAC7B;CACD,UAAU;EACT;;EAEA;CACD,+BAA+B;CAC/B,kBAAkB;EACjB;;EAEA;CACD,yBAAyB;CACzB,mBAAmB;CACnB,qBAAqB;EACpB;AACF;EAAA,WAAA;AAAoB;AAApB;;EAAA;IAAA,eAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;;AAIlB;EAAA,gBAA6B;EAA7B,aAA6B;EAA7B,yBAAA;AAA6B;AAG3B;EAAA,iBAA2C;EAA3C,kBAA2C;EAA3C,sDAAA;AAA2C;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;EAE7C;KACG;EAED;EAAA,uBAAuI;EAAvI,iBAAuI;EAAvI,kBAAuI;EAAvI,yDAAuI;EAAvI,iBAAA;AAAuI;EAAvI;EAAA,sBAAuI;EAAvI,yDAAA;AAAuI;EAAvI;EAAA,sBAAuI;EAAvI,yDAAuI;EAAvI,kBAAuI;EAAvI,sDAAA;AAAuI;EAAvI;EAAA,sBAAuI;EAAvI,yDAAA;AAAuI;;EAIvI;EAAA,sBAAqC;EAArC,yDAAqC;EAArC,sBAAqC;EAArC,8BAAqC;EAArC,uGAAA;AAAqC;;EAIrC;EAAA,iBAA4B;EAA5B,kBAA4B;EAA5B,sDAAA;AAA4B;;EAI5B;EAAA,kBAA6H;EAA7H,yDAA6H;EAA7H,eAA6H;EAA7H,oBAA6H;EAA7H,6CAA6H;EAA7H,0CAA6H;EAA7H,uDAA6H;EAA7H,uGAAA;AAA6H;;EAA7H;EAAA,kBAA6H;EAA7H,yDAAA;AAA6H;;EAA7H;EAAA,kBAA6H;EAA7H,sDAA6H;EAA7H,oBAA6H;EAA7H,gDAAA;AAA6H;;EAA7H;EAAA,kBAA6H;EAA7H,yDAAA;AAA6H;EAE/H;;KAEG;;EAGD;EAAA,aAAyB;EAAzB,kBAAyB;EAAzB,yDAAA;AAAyB;;EAMzB;;;EAAA,eAAgD;EAAhD,oBAAgD;EAAhD,6CAAA;AAAgD;;EAAhD;;;EAAA,oBAAgD;EAAhD,gDAAA;AAAgD;EAGhD;EAAA,kBAAkI;EAAlI,aAAkI;EAAlI,UAAkI;EAAlI,wBAAkI;EAAlI,8BAAkI;EAAlI,yBAAkI;EAAlI,eAAkI;EAAlI,gBAAkI;EAAlI,oBAAkI;EAAlI,4CAAA;AAAkI;EAAlI;EAAA,+BAAkI;EAAlI,yDAAA;AAAkI;;EAIrI;EAAA,+BAAqB;EAArB,2DAAA;AAAqB;;EAIhB;EAAA,gBAA8Q;EAA9Q,aAA8Q;EAA9Q,mBAA8Q;EAA9Q,uBAA8Q;EAA9Q,sBAA8Q;EAA9Q,iBAA8Q;EAA9Q,sBAA8Q;EAA9Q,yDAA8Q;EAA9Q,kBAA8Q;EAA9Q,uDAA8Q;EAA9Q,kBAA8Q;EAA9Q,mBAA8Q;EAA9Q,oBAA8Q;EAA9Q,uBAA8Q;EAA9Q,kBAA8Q;EAA9Q,gBAA8Q;EAA9Q,oBAA8Q;EAA9Q,gDAAA;AAA8Q;;EAA9Q;EAAA,sBAA8Q;EAA9Q,uDAA8Q;EAA9Q,kBAA8Q;EAA9Q,sDAA8Q;EAA9Q,oBAA8Q;EAA9Q,gDAAA;AAA8Q;;EAA9Q;EAAA,WAA8Q;EAA9Q,oBAA8Q;EAA9Q,0DAAA;AAA8Q;;EAA9Q;EAAA,oBAA8Q;EAA9Q,wDAAA;AAA8Q;;EAA9Q;EAAA,sBAA8Q;EAA9Q,yDAAA;AAA8Q;;AAGpR;EAKU,sBAAsB;AAChC;;AAGE;EAAA,aAAwD;EAAxD,mBAAwD;EAAxD,wBAAwD;EAAxD,gBAAwD;EAAxD,oBAAwD;EAAxD,gDAAA;AAAwD;AAGxD;EAAA,cAAA;AAAW;AAGX;EAAA,cAAA;AAAY;AAGb;EAAA,kBAC4I;EAD5I,qBAC4I;EAD5I,cAC4I;EAD5I,WAC4I;EAD5I,6BAC4I;EAD5I,iBAC4I;EAD5I,iCAC4I;EAD5I,oEAC4I;EAD5I,sCAC4I;EAD5I,iBAC4I;EAD5I,mBAC4I;EAD5I,oBAC4I;EAD5I,oBAC4I;EAD5I,6CAAA;AAC4I;AAD5I;EAAA,sCAC4I;EAD5I,kEAAA;AAC4I;AAD5I;EAAA,0CAC4I;EAD5I,uDAC4I;EAD5I,uGAAA;AAC4I;AAD5I;EAAA,+BAC4I;EAD5I,sBAC4I;EAD5I,yDAC4I;EAD5I,sCAC4I;EAD5I,oBAC4I;EAD5I,gDAAA;AAC4I;AAD5I;EAAA,sBAC4I;EAD5I,yDAC4I;EAD5I,oBAC4I;EAD5I,gDAAA;AAC4I;AAD5I;EAAA,sBAC4I;EAD5I,sDAC4I;EAD5I,oBAC4I;EAD5I,gDAAA;AAC4I;CAI3I;EAAA,qBAAwJ;EAAxJ,qBAAwJ;EAAxJ,0BAAwJ;EAAxJ,gBAAwJ;EAAxJ,oBAAwJ;EAAxJ,6CAAA;AAAwJ;CAAxJ;EAAA,iCAAwJ;EAAxJ,iEAAwJ;EAAxJ,sCAAwJ;EAAxJ,+BAAwJ;EAAxJ,wDAAA;AAAwJ;CAAxJ;EAAA,oBAAwJ;EAAxJ,gDAAA;AAAwJ;;AAKzJ;EAAA,aAA2J;EAA3J,eAA2J;EAA3J,mBAA2J;EAA3J,sBAA2J;EAA3J,iBAA2J;EAA3J,sBAA2J;EAA3J,yDAA2J;EAA3J,qBAA2J;EAA3J,sBAA2J;EAA3J,oBAA2J;EAA3J,uBAA2J;EAA3J,kBAA2J;EAA3J,eAA2J;EAA3J,oBAA2J;EAA3J,gDAAA;AAA2J;;AAA3J;EAAA,sBAA2J;EAA3J,yDAA2J;EAA3J,oBAA2J;EAA3J,gDAAA;AAA2J;;AAG5J;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB,eAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,SAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,QAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,QAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,wBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,QAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,4BAAA;AAAmB;;AAAnB;EAAA,4BAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,6BAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,wBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,UAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,uBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,+LAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB,+LAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB,+LAAA;AAAmB;;AAAnB;EAAA,+LAAA;AAAmB;;AAAnB;;EAAA;IAAA,WAAA;EAAmB;AAAA;;AAAnB;EAAA,yDAAA;AAAmB;;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB,kDAAA;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB,kDAAA;EAAmB;AAAA;;AAAnB;EAAA,6BAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,gDAAA;AAAmB;;AAAnB;EAAA,gDAAA;AAAmB;;AAAnB;EAAA,gDAAA;AAAmB;;AAAnB;EAAA,gDAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,uBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,uBAAA;AAAmB;;AAAnB;EAAA,8BAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,WAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,SAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,gEAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB,qDAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,gEAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,uBAAA;AAAmB;;AAAnB;EAAA,uBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,wBAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,sCAAA;AAAmB;;AAAnB;EAAA,wCAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;;AAAnB;EAAA,sCAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,qDAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,qEAAA;AAAmB;;AAAnB;EAAA,4EAAA;AAAmB;;AAAnB;EAAA,yEAAA;AAAmB;;AAAnB;EAAA,sEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,oCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB,kCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,sCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,qCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,qCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,qCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,mCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,sCAAmB;EAAnB,mEAAA;AAAmB;;AAAnB;EAAA,sCAAmB;EAAnB,4EAAA;AAAmB;;AAAnB;EAAA,qCAAmB;EAAnB,4EAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,4BAAA;AAAmB;;AAAnB;EAAA,YAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,aAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,wBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,uBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,qBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,mBAAA;AAAmB;;AAAnB;EAAA,oBAAA;AAAmB;;AAAnB;EAAA,sBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,0BAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,cAAA;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,cAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,oBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,iBAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,eAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,2BAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,cAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,kBAAA;AAAmB;;AAAnB;EAAA,iBAAA;AAAmB;;AAAnB;EAAA,wBAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,2DAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,0DAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,2DAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,2DAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,gBAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,wDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,2DAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,4CAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB,uGAAA;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB,uGAAA;AAAmB;;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB,uGAAA;AAAmB;;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB,uGAAA;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,uGAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,iLAAA;AAAmB;;AAAnB;EAAA,iLAAA;AAAmB;;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;;AAAnB;EAAA,0BAAA;AAAmB;;AAAnB;EAAA,0BAAA;AAAmB;;AAAnB;EAAA,sDAAA;AAAmB;;AAAnB;EAAA,wDAAA;AAAmB;;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB,iNAAA;EAAmB;AAAA;;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB,2MAAA;EAAmB;AAAA;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,yBAAA;AAAmB;;AAAnB;EAAA,qDAAA;AAAmB;;AAAnB;EAAA,uDAAA;AAAmB;;AAAnB;EAAA,6BAAA;AAAmB;;AAanB;;;;;;;;;;;;;GAaG;;AAEH;;GAEG;;AAEH;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG;;AAEH;AACA,YAAY;AACZ,4BAA4B;AAC5B;AACA;AACA,uCAAuC;AACvC;AACA;CACC,qBAAqB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB,2BAA2B;EACzB,cAAc;EACd,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;AACF;;;AAGA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,SAAS;EACX;;;AAGF;;AAEA;EACE;IACE,SAAS;EACX;;;AAGF;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA,eAAe;;AAEf;;AAEA;EACE,eAAe;AACjB;AACA;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EAEE,UAAU;EACV,kBAAkB;EAClB;iBACe;EACf,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;AACA;;;EAGE,2CAA2C;EAK3C,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,SAAS;EACT,mBAAmB;AAVrB;AAYA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AACA;;;;GAIG;AACH;;;;;;;;;;;;;;;GAeG;AACH;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;;;;GAIG;AACH;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;;AAErB;AACA;EACE;AACF;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;AACA,WAAW;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;;AAEjB;AACA;EACE,UAAU;EACV,OAAO;EACP,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,QAAQ;EACR,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ;AACF;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,QAAQ;IACR,UAAU;IACV,UAAU;AACd;;;AAGA;EACE;AACF;;AAEA,kCAAkC;AAClC;;;;IAII,sEAAsE;AAC1E;;AAEA;EACE,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;;;;AAKA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;CACC;AACD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;GAEG;AACH;;;GAGG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;AACA,YAAY;AACZ,4BAA4B;AAC5B;AACA;AACA,uCAAuC;AACvC;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;;AAEA;;;;;;;;;;;;GAYG;;;AAGH;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;;AAEpB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG;;;AAGH;;GAEG;;AAEH;EACE,cAAc;EACd,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;;;;;AAMA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;GAOG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,UAAU;;EAEZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;;;AAIA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ;qBACmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE;qBACmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;;;AAIA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;8BAC4B;EAC5B,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,OAAO;EACT;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;;EAEvB;;;AAGF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE;;yBAEqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,WAAW;EACb;;EAEA;;KAEG;;EAEH;;;;;;;KAOG;;EAEH;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE;wBACoB;EACtB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;EACrC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,aAAa,EAAE,sBAAsB;EACvC;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;;;KAGG;;EAEH;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE;wBACoB;EACtB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;;AAGF;;AAEA;;EAEE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;MACI,kBAAkB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;;AAE5B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE;;KAEG;;;EAGH;IACE;eACW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;;KAEG;EACH;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;cACU;EACZ;AACF;;AAEA;EACE;;KAEG;;EAEH;;;KAGG;AACL;;AAEA;EACE;;KAEG;;;EAGH;;;KAGG;AACL;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;IACjC,uCAAuC;EACzC;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,WAAW;EACb;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;AAEF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mCAAmC;IACnC,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;;EAEtB,kBAAkB;;EAElB,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB,cAAc,EAAE,cAAc;;AAEpD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB;CACD;AACD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,WAAW;EACX;;uBAEqB;EACrB,6BAA6B;;AAE/B;;AAEA;EACE,WAAW,GAAG,0BAA0B;EACxC,YAAY,EAAE,0CAA0C;AAC1D;;;AAGA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAElB,kBAAkB;EAElB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW,EACd,YAAY,EACV,mBAAmB,EACtB,2BAA2B;EAClD,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EAEf,kBAAkB;EAElB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B,EAAE,mBAAmB;EAC/C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAE,mBAAmB;EACvC,mBAAmB,EAAE,mBAAmB;EACxC,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;AACA,wBAAwB;AACxB,+BAA+B;AAC/B;;AAEA;AACA,iCAAiC;AACjC;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA,YAAY;AACZ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;;AAEZ;CACC,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CAGzB,iBAAiB;CACjB,2BAA2B;;EAE1B;EACA;CACD,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,SAAS;CACT,QAAQ;EACP;EACA;CACD,oCAAoC;EACnC;EACA;CACD,UAAU;CACV,QAAQ;EACP;EACA;CACD,wBAAwB;CACxB,WAAW;EACV;EACA;CACD,yBAAyB;EACxB;EACA;CACD,yBAAyB;EACxB;EACA;;KAEG;EACH;CACD,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;CAC3B,UAAU;CACV,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,uCAAuC;CACvC,kBAAkB;CAClB,8FAA8F;EAC7F;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,UAAU;IACV,8CAA8C;AAClD;EACE;;;;;;;;;;;;KAYG;EACH;CACD,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,iBAAiB;CACjB,4FAA4F;CAC5F,0BAA0B;CAC1B,2BAA2B;CAC3B,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,6CAA6C;CAC7C,iDAAiD;CACjD,gBAAgB;EACf;EAz8EF;EAAA,0BA08EA;EA18EA,kBAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,WAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,SAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,QAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,UAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,YAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,UAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,qEAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,wBA08EA;EA18EA,wDA08EA;EA18EA,0BAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,0BA08EA;EA18EA,yBAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,kBAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,aAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,QAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,YAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,WAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,qBAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,iBAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,sBA08EA;EA18EA,yDAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,kBA08EA;EA18EA,yDAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,wBA08EA;EA18EA,wDA08EA;EA18EA,0BAAA;AA08EA;EA18EA;EAAA,gBA08EA;EA18EA,0BAAA;AA08EA;EA18EA;EAAA,uBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;EAAA,iBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;EAAA,kBA08EA;EA18EA,kBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;EAAA,iBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;EAAA,kBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;EAAA,kCAAA;AA08EA;EA18EA;EAAA,kBA08EA;EA18EA,uDAAA;AA08EA;EA18EA;EAAA,kBA08EA;EA18EA,uDAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,gDAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,gDAAA;AA08EA;EA18EA;EAAA,aAAA;AA08EA;EA18EA;EAAA,gFA08EA;EA18EA,oGA08EA;EA18EA,uGAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,qCAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,SAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,WAAA;AA08EA;EA18EA;EAAA,8BA08EA;EA18EA,mBAAA;AA08EA;EA18EA;EAAA,2GA08EA;EA18EA,yGA08EA;EA18EA,4FAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,yDAAA;AA08EA;EA18EA;EAAA,8BA08EA;EA18EA,mBAAA;AA08EA;EA18EA;;EAAA;IAAA,2BA08EA;IA18EA,kDAAA;EA08EA;;EA18EA;IAAA,eA08EA;IA18EA,kDAAA;EA08EA;AAAA;EA18EA;EAAA,6BAAA;AA08EA;EA18EA;EAAA,kBA08EA;EA18EA,uDAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,sBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,sBA08EA;EA18EA,yDAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,0DAAA;AA08EA;EA18EA;EAAA,0BA08EA;EA18EA,uBA08EA;EA18EA,+LAAA;AA08EA;EA18EA;;EAAA;;IAAA;MAAA,2BA08EA;MA18EA,kDAAA;IA08EA;;IA18EA;MAAA,eA08EA;MA18EA,kDAAA;IA08EA;EAAA;;EA18EA;IAAA,6BAAA;EA08EA;AAAA;EA18EA;EAAA,sBA08EA;EA18EA,yDAAA;AA08EA;EA18EA;EAAA,kBA08EA;EA18EA,yDAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,gDAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,gDAAA;AA08EA;EA18EA;EAAA,oBA08EA;EA18EA,wDAAA;AA08EA;EA18EA;;EAAA;IAAA,wBAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,4BAAA;EA08EA;;EA18EA;IAAA,6BAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,iBAAA;EA08EA;;EA18EA;IAAA,gBA08EA;IA18EA,mBAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,oBAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,qBAAA;EA08EA;;EA18EA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,oBA08EA;IA18EA,uBAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,mBAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,uBAAA;EA08EA;;EA18EA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,sBAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,qBAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,uBAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,sBAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,qBAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,qBA08EA;IA18EA,sBAAA;EA08EA;;EA18EA;IAAA,6BAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,uBAAA;EA08EA;;EA18EA;IAAA,SAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,iBAAA;EA08EA;;EA18EA;IAAA,iBA08EA;IA18EA,kBAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,mBAAA;EA08EA;;EA18EA;IAAA,iBA08EA;IA18EA,oBAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,mBAAA;EA08EA;;EA18EA;IAAA,sBAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,8BAAA;EA08EA;;EA18EA;IAAA,mBAAA;EA08EA;;EA18EA;IAAA,qBAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,kCAAA;EA08EA;;EA18EA;IAAA,sBAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,qDAAA;EA08EA;;EA18EA;IAAA,iBAAA;EA08EA;;EA18EA;IAAA,kBAAA;EA08EA;;EA18EA;IAAA,uBAAA;EA08EA;;EA18EA;IAAA,kBAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;;EA18EA;IAAA,mBA08EA;IA18EA,oBAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,kBAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,mBAAA;EA08EA;;EA18EA;IAAA,SAAA;EA08EA;;EA18EA;IAAA,iBA08EA;IA18EA,oBAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,YAAA;EA08EA;;EA18EA;IAAA,aAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,mBAAA;EA08EA;;EA18EA;IAAA,mBAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,eAAA;EA08EA;;EA18EA;IAAA,mBAAA;EA08EA;;EA18EA;IAAA,kBAAA;EA08EA;;EA18EA;IAAA,8BAAA;EA08EA;;EA18EA;IAAA,kBAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,UAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,oCAAA;EA08EA;;EA18EA;IAAA,mBAAA;EA08EA;;EA18EA;IAAA,WAAA;EA08EA;;EA18EA;IAAA,QAAA;EA08EA;;EA18EA;IAAA,mBA08EA;IA18EA,sBAAA;EA08EA;;EA18EA;IAAA,iBA08EA;IA18EA,kBAAA;EA08EA;;EA18EA;IAAA,qBA08EA;IA18EA,sBAAA;EA08EA;;EA18EA;IAAA,gBAAA;EA08EA;;EA18EA;IAAA,sBAAA;EA08EA;;EA18EA;IAAA,oBAAA;EA08EA;;EA18EA;IAAA,iBAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,mBAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;;EA18EA;IAAA,0BAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,oCAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,mBAAA;EA08EA;AAAA;EA18EA;;EAAA;IAAA,gDAAA;EA08EA;;EA18EA;IAAA,kBA08EA;IA18EA,mBAAA;EA08EA;AAAA","sourcesContent":["\n\n@tailwind base;\n/* Firefox */\n* {\n\tscrollbar-width: thin;\n\tscrollbar-color: var(--blueSecondary) var(--lightPrimary);\n  }\n  \n  /* Chrome, Edge, and Safari */\n  *::-webkit-scrollbar {\n\twidth: 3px;\n  }\n  \n  *::-webkit-scrollbar-track {\n\tbackground: var(--lightPrimary);\n\tborder-radius: 5px;\n  }\n  \n  *::-webkit-scrollbar-thumb {\n\tbackground-color: #6e6e6e;\n\tborder-radius: 14px;\n\tborder: 1x solid gray;\n  }\n@tailwind components;\n\n\n.navbar-custom .navbar-nav { \n  @apply  mt-4  flex justify-end \n}\n.my-react-select-container .my-react-select__menu {\n    @apply bg-navy-800 dark:bg-navy-800 border ;\n  }\n  /* .my-react-select-container {\n  } */\n  .my-react-select-container .my-react-select__control {\n    @apply bg-white dark:bg-navy-800 rounded-[0.375rem]  border dark:border-gray-400 hover:border-gray-400 dark:hover:border-gray-400 p-1.5;\n  }\n\n  .my-react-select-container .my-react-select__control--is-focused {\n    @apply border-gray-400    shadow-none;\n  }\n\n  .my-react-select-container .my-react-select__menu {\n    @apply bg-navy-800  border  ;\n  }\n\n  .my-react-select-container .my-react-select__option {\n    @apply text-navy-700 text-[14px] dark:text-white bg-white hover:bg-gray-400 dark:bg-navy-800 dark:hover:bg-gray-400 shadow-sm;\n  }\n  /* .my-react-select-container .my-react-select__option--is-focused {\n    @apply bg-neutral-200 dark:bg-neutral-800;\n  } */\n\n  .my-react-select-container .my-react-select__indicator-separator {\n    @apply bg-gray-700 hidden;\n  }\n\n  .my-react-select-container .my-react-select__input-container,\n  .my-react-select-container .my-react-select__placeholder,\n  .my-react-select-container .my-react-select__single-value {\n    @apply text-navy-700 dark:text-white text-[14px];\n  }\n  .error{\n    @apply absolute bottom-[-12px] right-0 justify-end font-medium text-[12px] text-red-600 dark:!text-[#ff4242]   !flex !items-center;\n  }\n\n  ::placeholder {\n\t@apply !text-gray-400;\n  }\n\n  .btn_sm {\n      @apply   mt-4 font-medium flex justify-center items-center rounded text-center  bg-[#fe7b05] text-white border px-4 py-3 dark:border-white border-white hover:bg-navy-900 hover:text-white  hover:border-yellow-600 hover:focus:ring-yellow-600 focus:right-4 focus:ring-white;\n    }\n\n.navbar-custom .navbar-nav{\n\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.navbar-custom .navbar-nav .nav-item {\n  @apply flex text-white items-center p-3 border-opacity-10\n}\n.dropdown-item{\n  @apply block\n}\n.dropdown-menu.show{\n  @apply  block\n}\n.inputfild {\n\t@apply relative  block w-full text-navy-900 mb-2 p-3.5 bg-white/0 border dark:border-gray-400 !rounded-[5px] text-sm shadow-sm  !border-[#8c9fb3] dark:text-white !placeholder-gray-500  disabled:bg-white/0 \n\tdisabled:dark:text-[#93929d]  disabled:dark:border-[#414154] disabled:text-[#c5c5c5]  disabled:border-[#c5c5c5] disabled:!pointer-events-none \n      \n    } \n\tlabel {\n\t\t@apply !text-[14px] dark:text-white text-navy-900 font-medium  disabled:bg-white/0 disabled:!text-[#414154]  disabled:!border-[#414154] inline-block mb-2\n\t\t\n\t}\n\n.tab {\n\t@apply px-3  py-3 text-[14px] rounded border-gray-700 dark:border-white border text-gray-700 dark:text-white text-center cursor-pointer  flex items-center ;\n}\n\n@tailwind utilities;\n\n@layer base {\n\tbody {\n    font-size: 1.05rem;\n    font-family: \"Poppins\", sans-serif !important; \n    text-align: center;\n    font-weight: 400;\n    line-height: 1.5;\n  }\n\n}\n\n/* .slider {\n  margin:0 20px;\n  overflow:\"hidden\";\n  padding:2rem 0;\n}\n\n.slider {\n  margin: 0 20px;\n  overflow: \"hidden\";\n  padding: 1rem 0;\n  height: 65px;\n  display: flex;\n  align-items: center;\n} */\n\n/* li.react-multi-carousel-item {\n  margin-right: 21px;\n} */\n\n.slider img {\n  width: 100%;\n  border-radius:10px;\n}\n\nbutton.react-multiple-carousel__arrow {\n  display: none;\n}\n\n/* .react-multi-carousel-list {\npadding: 0rem 0 2rem 0;\n} */\n\n.custom-dot-list-style button{\nborder: none;\nbackground: rgb(255, 68, 68);\n}\n.react-multi-carousel-dot.react-multi-carousel-dot--active button{\nbackground: rgb(255, 68, 68) !important;\n}\n.error{\n\tdisplay: inline-block;\n    /* width: 197px; */\n    /* white-space: nowrap; */\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n}\n\n.i::before {\n  content: \"\";\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  opacity: 20%;\n  background: white;\n/*   background: #3B82F6; */\n  /* Centering */\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n}\n\n.i:hover:before {\n  animation: anim-in 0.7s forwards ease-out;\n}\n\n@keyframes anim-in {\n  100% {\n    opacity: 0%;\n    border-radius: 0;\n    width: 600px;\n    height: 600px;\n  }\n  0% {\n    width: 0px;\n    height: 0px;\n    border-radius: 100%;\n    opacity: 20%;\n  }\n}\n\n\n.wrapper {\n  display: flex;\n  justify-content: space-around;\n  gap: 15px;\n}\n \n.container {\n  width: 28vmin;\n  height: 28vmin;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 1em 0;\n  position: relative;\n  background-color: #ffffff;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 15px;\n  text-align: center;\n  transition: transform 0.3s ease-in-out;\n}\n \n.container:hover {\n  transform: scale(1.05);\n}\n \n.icon {\n  color: red;\n  font-size: 2.5em;\n  text-align: center;\n}\n \nspan.num {\n  color: red;\n  font-weight: 600;\n  font-size: 2.5em;\n}\n \nspan.text {\n  color: #333;\n  font-size: 1.2em;\n  padding: 0.7em 0;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n \n@media screen and (max-width: 1024px) {\n  .wrapper {\n    width: 90vw;\n    flex-wrap: wrap;\n    gap: 20px;\n  }\n \n}\n \n@media screen and (max-width: 768px) {\n  .wrapper {\n    width: 90vw;\n    flex-wrap: wrap;\n    gap: 20px;\n  }\n \n  \n}\n \n@media screen and (max-width: 480px) {\n  .wrapper {\n    gap: 15px;\n  }\n \n  \n}\n\n.mobile-sidebar{\n  display: none;\n}\n.navbar-custom{\n  display: block;\n}\n\n/* responsive */\n\n@media (max-width: 1191px) {\n \n.Heading-01{\n  font-size: 50px;\n}\n}\n\n@media (max-width: 1170px) {\n  .navbar-custom{\n    display: none;\n  }\n  .mobile-sidebar{\n    display: block;\n  }\n  ul.menu-section {\n    display: none;\n}\n.Heading-01{\n  font-size: 50px;\n}\n}\n\n\nli {\n  list-style: none;\n}\n\n@keyframes hover {\n  50% {\n    transform: translateX(10px);\n  }\n}\n.offcanvas-menu > label {\n  top: 30px;\n  left: 30px;\n  position: absolute;\n  /* width: 40px;\n  height: 40px; */\n  cursor: pointer;\n  transition: 0.3s ease;\n  display: flex;\n  align-items: center;\n  z-index: 1;\n  top: 19px;\n}\n.offcanvas-menu label span,\n.offcanvas-menu label span::before,\n.offcanvas-menu label span::after {\n  transition: background 0.3s, transform 0.3s;\n}\n.offcanvas-menu label span,\n.offcanvas-menu label span::before,\n.offcanvas-menu label span::after {\n  content: \"\";\n  position: absolute;\n  height: 2px;\n  width: 20px;\n  left: 13px;\n  top: 18px;\n  background: #b3b3b3;\n}\n.offcanvas-menu label span::before {\n  transform: translateY(-12px);\n}\n.offcanvas-menu label span::after {\n  transform: translateY(12px);\n}\n.offcanvas-menu nav {\n  position: fixed;\n  height: 100%;\n  width: 350px;\n  left: -350px;\n  overflow: hidden;\n  background: #001227;\n  transition: 0.3s ease;\n  padding: 40px 30px;\n  top: 0;\n  z-index: 9;\n}\n/* .offcanvas-menu nav > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n} */\n/* .offcanvas-menu nav > div a {\n  font-size: 2.5rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  font-family: \"Monoton\", cursive;\n  background: linear-gradient(-90deg, #49a4ed 30%, #3d00a9 110%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.offcanvas-menu nav > div a i {\n  font-size: 4rem;\n  background: linear-gradient(120deg, #49a4ed 30%, #3d00a9 110%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n} */\n.offcanvas-menu nav > div label {\n  width: 30px;\n  height: 30px;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: 0.3s ease;\n}\n/* .offcanvas-menu nav > div label span,\n.offcanvas-menu nav > div label span:before,\n.offcanvas-menu nav > div label span:after {\n  background: #4d4d4d;\n} */\n.offcanvas-menu nav > ul {\n  margin-top: 30px;\n  counter-reset: nav-link-count;\n}\n.offcanvas-menu nav > ul li {\n  cursor: pointer;\n  padding: 10px 0;\n  transform: translateX(-30px);\n  opacity: 0;\n  transition: 0.4s ease;\n  counter-increment: nav-link-count;\n}\n.offcanvas-menu nav > ul li a {\n  font-size: 2.5rem;\n  line-height: 1.5;\n  font-weight: 400;\n  color: #333333;\n  display: block;\n}\n.offcanvas-menu nav > ul li a::after {\n  content: \" : \" counter(nav-link-count);\n}\n.offcanvas-menu nav > ul li:hover {\n  animation: hover 0.5s;\n}\n.offcanvas-menu input[type=checkbox] {\n  display: none;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ label {\n  opacity: 0;\n  pointer-events: none;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav {\n  left: 0;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav label span {\n  background: transparent;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav label span:before {\n  transform: rotate(-45deg);\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav label span:after {\n  transform: rotate(45deg);\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav label span:before,\n.offcanvas-menu input[type=checkbox]:checked ~ nav label span:after {\n  transition-delay: 0.2s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li {\n  opacity: 1;\n  transform: translateX(0px);\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(1) {\n  transition-delay: 0.1s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(2) {\n  transition-delay: 0.2s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(3) {\n  transition-delay: 0.3s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(4) {\n  transition-delay: 0.4s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(5) {\n  transition-delay: 0.5s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(6) {\n  transition-delay: 0.6s;\n}\n.offcanvas-menu input[type=checkbox]:checked ~ nav ul li:nth-child(7) {\n  transition-delay: 0.7s;\n}\n\n \n.mobile-login .nav-item, .dropdown-item {\n  line-height: normal;\n  \n}\n.mobile-login .dropdown-menu li a{\n  color: rgb(107 114 128 / var(--tw-text-opacity)) \n}\n\n.mobile-menu  .dropdown-menu {\n    position: relative;\n    --tw-bg-opacity: 1;\n    background: transparent;\n    width: 100%;\n    padding-left: 15px;\n    box-shadow: none;\n}\n.mobile-menu  .dropdown-item {\n  --tw-text-opacity: 1;\n  color: #bcccef;\n  padding: 0;\n}\n.mobile-menu .nav-item, .mobile-menu .dropdown-item {\n  line-height: 3.5rem;\n}\n.mobile-menu .dropdown .dropdown-item {\n  line-height: 3rem;\n  padding: 0;\n}\n.mobile-menu a.nav-item.dropdown-toggle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.mobile-menu .navbar-nav li  {\n  \n  text-align: left;\n  /* padding: 18px 0; */\n  width: 100%;\n}\n.mobile-menu .dropdown{\nwidth: 100%;\n}\n.inner-dpd li a {\n  color: #747799 !important;\n}\n.mobile-menu .dropdown-item:hover{\n  color: #bcccef;\n}\n.mobile-menu .dropdown:hover>.dropdown-menu, .mobile-login .dropdown:hover>.dropdown-menu{\n  display: block !important;\n}\n.newselect.countryselecter {\n  position: absolute;\n  top: 42px;\n  padding: 0 10px;\n \n}\n.newselect.countryselecter .my-react-select__menu{\n  z-index: 8;\n  left: 0;\n  width: 250px;\n}\n.newselect.countryselecter .my-react-select__control{\n  position:  relative !important;\n  width: auto;\n}\n.countryselecter .my-react-select__control {\n  position: absolute;\n  width: auto;\n  border: none;\n  white-space: nowrap;\n  background: none !important;\n  left: -9px;\n  top: 33px;\n  z-index: 2;\n}\n\n.countryselecter .my-react-select__menu{\n  z-index: 8;\n  left: -8px;\n  top:75px;\n  width: 150px;\n}\n.signup-phone input{\n  padding-left: 106px;\n}\n.signup-phone.pad-left input {\n    padding-left: 90px;\n}\n.countryselecter .my-react-select__indicators {\n  padding: 2px 0px 2px 8px !important;\n  position: absolute;\n  right: -21px;\n  top: -1px\n}\n.freq.newselect .countryselecter .my-react-select__control{\n  left: -4px;\n  top: 36px;\n}\n.freq.newselect .countryselecter .my-react-select__indicators{\n  top: 7px;\n  padding:0;\n}\n.invoce-country .countryselecter .my-react-select__control {\n    position: absolute;\n    width: auto;\n    border: none;\n    white-space: nowrap;\n    background: none !important;\n    left: 0px;\n    top: 5px;\n    z-index: 2;\n    padding: 0;\n}\n\n\ninput.inputfild:focus-visible {\n  outline: none\n}\n\n/* Change the white to any color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover, \ninput:-webkit-autofill:focus, \ninput:-webkit-autofill:active{\n    -webkit-box-shadow: 0 0 0 30px rgba(255, 255, 255, 0) inset !important;\n}\n\n.countryselecter .my-react-select__indicators{\n  display: none;\n}\ninput.inputfild {\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 300;\n  margin-top: 15px;\n  height: 46px;\n  font-size: 1rem;\n}\n.countryselecter .my-react-select__single-value {\n  font-weight: 600;\n}\n\n\n\n  \ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n  -webkit-appearance: none; \n  margin: 0; \n}\n\n.share-icon {\n  border: 1px solid rgba(245, 202, 61, 0.4);\n  border-radius: 1.25rem;\n  cursor: pointer;\n  height: 55px;\n  line-height: 52px;\n  text-align: center;\n  width: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.CircularProgressbar .CircularProgressbar-path {\n  stroke: #fe7b05;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.5s ease 0s;\n}\n\n.invoce-country.frmnew .countryselecter .my-react-select__control {\n top: 2px !important\n}\n\n.slider {\n  margin:0 6px;\n  overflow:\"hidden\";\n  padding:1rem 0;\n}\n\n.slider img , .slider video {\n  width: 100%;\n  border-radius: 4px;\n} \n\n/* .react-multi-carousel-list {\npadding: 0rem 0 2rem 0;\n} */\n/* .react-multi-carousel-list  button.react-multiple-carousel__arrow {\n  display: block;\n  z-index: 0;\n} */\n.react-multi-carousel-list button.react-multiple-carousel__arrow {\n  background: #000;\n}\n.react-multi-carousel-list .react-multiple-carousel__arrow--left {\n  left: calc(0% + 1px);\n}\n.react-multiple-carousel__arrow--right {\n  right: calc(0% + 1px);\n}\n\n.custom-dot-list-style button{\nborder: none;\nbackground: rgb(255, 68, 68);\n}\n.react-multi-carousel-dot.react-multi-carousel-dot--active button{\nbackground: rgb(255, 68, 68) !important;\n}\n\n@media (max-width: 595px) {\n  span.share-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n}\n}\n\n/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n} */\n\n\n.box-border {\n  border: 1px solid #f9efef;\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.border-bot {\n  border-bottom: 1px solid #f9efef;\n  border-radius: 8px;\n\n}\n\ntable {\n\n  border-collapse: collapse;\n  width: 100%;\n}\n\ntd,\nth {\n  /* border: 1px solid #f9efef; */\n  text-align: left;\n  padding: 8px;\n}\n\nspan.keybt {\n  border: 1px solid #c9c4c4;\n  padding: 2px 10px;\n  border-radius: 3px;\n  /* margin: 0 auto; */\n  white-space: nowrap;\n}\n\n.loader-bt {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.box-dashboard-r {\n  width: 100%;\n  height: 100%;\n  display: block;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.height-full {\n  height: 100vh;\n}\n\n/* tr:nth-child(even) {\n  background-color: #dddddd;\n} */\n\n\n/* .dashboard-wrapper {\n  padding: 70px 45px;\n} */\n\n.copyicon {\n  color: #4a5568;\n  /* Equivalent to Tailwind's text-gray-800 */\n  font-size: 20px;\n}\n\n.copyicon:hover {\n  color: #d69e2e;\n  /* Equivalent to Tailwind's text-yellow-600 */\n  cursor: pointer;\n}\n\n.dark .copyicon {\n  color: #ffffff;\n  /* Equivalent to Tailwind's dark:text-white */\n}\n\n.tittle-name2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.no_data_available {\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n/* .spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  position: relative;\n  top: 0;\n  border: 2px solid transparent;\n  border-top-color: #050708;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n} */\n\n.text-danger.mt-1 {\n  position: absolute;\n  bottom: -26px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.table-box {\n  margin-top: 75px;\n}\n\n\n.accordion {\n  width: 100%;\n  max-width: 600px;\n}\n\n.accordion-item {\n  margin-bottom: 10px;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #1f1f1f;\n  box-shadow: 0 0 10px #00ffd544;\n}\n\n.accordion-header {\n  width: 100%;\n  padding: 16px;\n  font-size: 1rem;\n  background: #2a2a2a;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  color: #00ffd5;\n}\n\n.accordion-content {\n  max-height: 0;\n  overflow: hidden;\n  padding: 0 16px;\n  background: #1f1f1f;\n  transition: max-height 0.4s ease, padding 0.3s;\n}\n\n\n\n\n\n.lightboxjs {\n  margin: 0;\n  padding: 0;\n}\n\n.lightboxjs * {\n  box-sizing: border-box;\n}\n\n/* .lightboxjs img,\n.lightboxjs svg,\n.lightboxjs video {\n  display: block;\n  vertical-align: middle;\n  height: auto;\n  max-width: 100%;\n} */\n\n.slideshowBtn {\n  padding-bottom: 2px;\n}\n\n.closeIcon:hover,\n.closeIcon:focus,\n.iconsHeader svg:hover,\n.iconsHeader svg:focus,\n.prev1 span:hover,\n.next1:hover,\n.icon:hover {\n  text-decoration: none;\n  cursor: pointer;\n  /* color: rgb(230, 230, 230); */\n}\n\n.prevIcon:hover,\n.nextIcon:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: rgb(230, 230, 230);\n}\n\n.show {\n  display: flex;\n}\n\n.displayHidden {\n  display: none;\n}\n\n.thumbnail {\n  opacity: 1;\n  transition: all 0.3s;\n  cursor: pointer;\n  position: relative;\n}\n\n.next1 {\n  right: 1%;\n  padding-left: 2vw;\n  padding-right: 3vw;\n}\n\n.prev1 {\n  left: 2%;\n  padding-right: 2vw;\n}\n\n.thumbnails {\n  transition: border 0.3s;\n}\n\n.thumbnail {\n  display: inline;\n}\n\n.thumbnailsWithCaption {\n  width: 90%;\n}\n\n.thumbnailsOuterContainer {\n  position: absolute;\n  bottom: 4%;\n  height: 5vh;\n  width: 100vw;\n  z-index: 10000000;\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n\n.navigationDots {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n/* Mobile screens */\n@media screen and (min-width: 20em) {\n  .imageSlide {\n    height: 67vw;\n    width: 60%;\n  }\n\n  .thumbnailsOuterContainer {\n    position: absolute;\n    bottom: 7%;\n    width: 100vw;\n    /* width: 100%; */\n  }\n\n  .thumbnailsAndCaption {\n    height: 23vh;\n    bottom: 2%;\n\n  }\n\n  .hideControlsBar .slideshowImg {\n    /* height: 100vh; */\n  }\n\n  .rotateImgInnerContainer {\n    top: 8%;\n  }\n\n  .hideControlsBar .slideshowInnerContainer {\n    top: 0;\n  }\n\n  .thumbnail {\n    width: 80px;\n    max-width: 80px;\n    height: 7vh;\n  }\n\n  .videoThumbnailsOuterContainer {\n    bottom: 2%;\n  }\n\n  .imgTitleContainer {\n    padding-bottom: 16px;\n    width: 100vw;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .thumbnails {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .next1 {\n    right: 0.9%;\n  }\n\n  .prev1 {\n    left: 1.5%;\n  }\n}\n\n.thumbnail {\n  height: 5vh;\n  border-radius: 6px;\n  margin-right: 7px;\n  object-fit: cover;\n}\n\n\n\n.thumbnailsOuterContainerMetadata {\n  width: 78vw;\n}\n\n.videoThumbnailsOuterContainer {\n  bottom: 5%;\n}\n\n.thumbnailsAndCaption {\n  height: 19vh;\n}\n\n.htmlVideoOuterContainer video {\n  height: 100%;\n  max-height: 70vh;\n  width: 100%;\n}\n\n.caption {\n  position: absolute;\n  bottom: 14%;\n  width: 100vw;\n  z-index: 10000000;\n  margin-top: 10px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.galleryImg {\n  cursor: pointer;\n  margin: 0.2em;\n}\n\n.modalContainer {\n  width: 100vw;\n  /* height: 100%;\n  max-height: 100%; */\n  direction: ltr;\n  overflow: hidden;\n  touch-action: none;\n  padding: 0;\n  overflow-y: hidden;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000000;\n}\n\n.slideshowAnimContainer {\n  /* height: 100%;\n  max-height: 100%; */\n  direction: ltr;\n  overflow: hidden;\n  touch-action: none;\n  padding: 0;\n  overflow-y: hidden;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* position: fixed; */\n  top: 0;\n  left: 0;\n  z-index: 1000000;\n}\n\n.fullScreenContainer img {\n  height: 100vh;\n  max-width: 100%;\n  /* max-height: 100vh; */\n}\n\n.imageInnerContainer img {\n  height: 80vh;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.imageInnerContainer {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  top: 0;\n  align-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  z-index: 1000000;\n}\n\n.magnifyWrapper {\n  margin-bottom: 3em;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slideshowInnerContainer {\n  position: fixed; \n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: top 0.2s ease-in-out 0s;\n  top: 12%;\n  align-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  z-index: 1000000;\n}\n\n.slideshowInnerVideoContainer {\n  top: 6%;\n}\n\n.slideshowInnerContainerThumbnails {\n  top: 12%;\n}\n\n.hideControlsBar  {\n  top: 0;\n}\n\n.fullScreenContainer {\n  top: 0;\n}\n\n.lightboxContainer {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.next1,\n.prev1 {\n  top: calc(50% - 20px);\n  position: absolute;\n  display: flex;\n  transition: all 0.2s;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 2vh;\n  padding-top: 2vh;\n  user-select: none;\n  cursor: pointer;\n  font-weight: bold;\n  border-radius: 30px;\n  width: 40px;\n  height: 40px;\n  font-size: 18px;\n  z-index: 10000000;\n}\n\n\n\n.next1:hover,\n.prev1:hover {\n  color: rgb(230, 230, 230);\n}\n\n.slideshowAnimImg {\n  position: absolute;\n  max-width: 100vw;\n}\n\n.controls {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.iconsHeader {\n  color: white;\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  /* align-items: center;\n    justify-content: center; */\n  cursor: pointer;\n  top: 10px;\n  right: 45px;\n  z-index: 999999999;\n  /* padding: 0.14vw; */\n}\n\n.ytVideo {\n  aspect-ratio: 16 / 9;\n  height: 65vh;\n  width: 100%;\n}\n\n.videoOuterContainer {\n  width: 65%;\n  margin-left: auto;\n  margin-right: auto;\n  height: 60vh;\n  max-height: 65vh;\n}\n\n.htmlVideoOuterContainer {\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.customVideoContainer, .customEmbedContainer {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.videoIconsHeader {\n  position: fixed;\n  top: 4%;\n  right: 3%;\n}\n\n.lightbox .iconsHeader svg {\n  transition: 0.3s all;\n}\n\n.iconsHeader svg:active {\n  transform: scale(0.97);\n}\n\n.imgTitle {\n  text-align: center;\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.iconsHeader svg {\n  margin-left: 0.6em;\n  padding: 0.2em;\n  transition: all 0.1s;\n  /* width: 32px;  */\n  /* font-size: 18px; */\n  line-height: 16px;\n  vertical-align: baseline;\n}\n\n.icon {\n  /* width: 32px;  */\n}\n\n@media screen and (min-width: 6em) {\n  .iconsHeader {\n    top: 3%;\n  }\n\n  .slideshowAnimContainer {\n    width: 100vw;\n  }\n\n  .iconsHeader svg {\n    /* width: 34px;  */\n    padding-right: 0.3em;\n  }\n\n  .lightboxjs img {\n    cursor: pointer;\n  }\n\n  .thumbnail {\n    height: 9vh;\n    /* width: 22vw; */\n  }\n\n  .next1 {\n    top: calc(48% - 20px);\n  }\n\n  .prev1 {\n    top: calc(48% - 20px);\n\n  }\n\n\n}\n\n@media screen and (min-width: 39em) {\n  .slideshowAnimContainer {\n    width: 100vw;\n  }\n\n  .slideshowInnerContainer {\n    /* width: 100vw;\n    height: 95vh;\n    position: absolute; */\n  }\n\n  .imgTitleContainer {\n    padding-bottom: 0px;\n  }\n  \n\n  .next1 {\n    right: 0.7%;\n  }\n\n  /* .thumbnailsOuterContainer {\n    bottom: 10%;\n  } */\n\n  /* .hideControlsBar .slideshow_img {\n    height: 70vh;\n\n  }\n\n  .hideControlsBar {\n    top: 10%;\n  } */\n\n  .fullScreenContainer {\n    width: 100vw;\n    /* height: 100vh; */\n  }\n\n  .fullScreenContainer img {\n    height: 100vh;\n  }\n\n  .thumbnails {\n    margin-top: 0.6em;\n  }\n\n  .thumbnail {\n    /* height: 8vh; */\n    width: 80px;\n    max-width: 80px;\n  }\n\n  .iconsHeader svg {\n    /* width: 32px; \n      font-size: 32px; */\n  }\n\n  .prev1 {\n    left: 2.7%;\n    padding-right: 2vw;\n  }\n}\n\n/* Desktop screens */\n@media screen and (min-width: 42em) {\n  .imageSlide {\n    height: 70vh;\n    width: 80vw;\n  }\n\n  .innerContainerWithTopCaption {\n    top: 8%;\n  }\n\n  .slideshowImgFullscreen {\n    display: grid;\n    width: 92vw;\n    place-items: start;\n    margin-left: auto;\n    margin-right: auto;\n    scrollbar-gutter: stable both-edges;\n  }\n\n  .thumbnailsAndCaption {\n    bottom: 0%;\n  }\n  \n  .rotateImgInnerContainer {\n    top: 2%;\n  }\n\n  .slideshowInnerContainer img {\n    margin-top: 0vh;\n    /* width: 70vw; */\n  }\n\n  .fullScreenContainer img {\n    width: 80vw;\n  }\n\n  .slideshowInnerContainerFullScreen {\n    top: 0%;\n  }\n\n  .fullScreenLightboxImg {\n    margin-left: auto;\n    margin-right: auto;\n    height: 100vh;\n  }\n\n  .slideshowInnerContainerImgMetadata {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .slideshowInnerContainerFullScreen {\n    height: 100vh;\n    width: 100vw;\n    position: absolute;\n  }\n\n  .slideshowInnerContainerFullScreen img {\n    object-fit: contain;\n  }\n\n  .thumbnails {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    margin-top: 1.1em;\n  }\n\n  .thumbnails::-webkit-scrollbar {\n    display: none; /* Safari and Chrome */\n  }\n\n  .opacity-fade {\n    transition: opacity 0.3s;\n    -webkit-transition: opacity 0.3s;\n    opacity: 1;\n  }\n\n  .thumbnailsOuterContainer {\n    margin-top: 0.1em;\n    padding-top: 0.3em;\n    height: 5vh;\n    bottom: 11%;\n  }\n\n  .thumbnailsAndCaption {\n    bottom: 0%;\n  }\n\n  .thumbnail,\n  .imageSliderThumbnails img {\n    height: 10vh;\n    /* width: 7em; */\n  }\n\n  .slideshowAnimContainer {\n    width: 100vw;\n  }\n\n  /* .slideshowInnerContainer {\n    width: 100vw;\n    height: 95vh;\n  } */\n\n  .hideControlsBar {\n    /* height: 100vh; */\n  }\n\n  .fullScreenContainer {\n    width: 100vw;\n    /* height: 100vh; */\n  }\n\n  .iconsHeader svg {\n    /* width: 37px;\n      font-size: 34px; */\n  }\n\n  .prev1 {\n    left: 2%;\n    padding-right: 2vw;\n  }\n\n  .next1 {\n    right: 0.4%;\n  }\n\n  \n  .slideshowImgMetadata {\n    width: 78vw;\n  }\n\n  .prev1Metadata {\n    left: 1%;\n  }\n\n  .navigationDots {\n    gap: 8px;\n  }\n\n \n}\n\n@media screen and (min-width: 53em) {\n  \n  .slideshowImg {\n    display: grid;\n    width: 100vw;\n    height: 70vh;\n    place-items: start;\n    /* margin-top: 7vh; */\n  }\n\n  .slideshowImgWithCaption {\n    height: 68vh;\n  }\n\n  .hideControlsBar .slideshowImg, .hideControlsBarAndCaption .slideshowImg  {\n    padding-top: 12vh;\n  }\n\n  .fullScreenContainer .slideshowImg {\n    padding-top: 0vh;\n  }\n\n\n  .lightboxImg {\n      /* height: 70vh; */\n  }\n\n  .thumbnail {\n    width: 95px;\n    max-width: 80px;\n  } \n\n  .slideshowImgMetadata {\n    width: 78vw;\n  }\n}\n  \n\n@media screen and (min-width: 80em) {\n  .slideshowInnerContainer img {\n    /* width: 60vw; */\n  }\n\n  .fullScreenContainer img {\n    width: 80vw;\n  }\n}\n\n.lightIcon,\n.lightIcon svg {\n  background-color: white;\n  color: black;\n}\n\n.lightIcon:hover,\n.lightIcon svg:hover {\n  background-color: white;\n  color: black;\n  fill: black;\n}\n\n.darkIcon,\n.darkIcon svg {\n  background-color: transparent;\n  /* background-color: #151515; */\n  color: silver;\n  fill: silver;\n}\n\n.darkIcon:hover,\n.darkIcon svg:hover {\n  color: rgba(107, 107, 107, 0.8);\n  fill: rgba(107, 107, 107, 0.8);\n}\n\n/* Header icons  */\n.lightHeaderIcon svg {\n  background-color: white;\n  color: black;\n  fill: black;\n}\n\n.lightHeaderIcon svg:hover {\n  background-color: white;\n  color: rgb(24, 24, 24, 0.8);\n  fill: rgb(24, 24, 24, 0.8);\n\n}\n\n.darkHeaderIcon svg {\n  background-color: transparent;\n  /* background-color: #151515; */\n  color: #626b77;\n  fill: #626b77;\n}\n\n.darkHeaderIcon svg:hover {\n  color: rgba(99, 99, 99, 0.8);\n  fill: rgba(99, 99, 99, 0.8);\n}\n\n.magnifierImage {\n  object-fit: contain;\n}\n\n.thumbnails .active {\n  border: solid rgb(107, 133, 206) 2px;\n}\n\n.inactiveThumbnailBorder {\n  border: solid transparent 2px;\n}\n\n.thumbnails {\n  width: 95%;\n}\n\n.emblaThumbs {\n  --thumbs-slide-spacing: 2px; \n  /* --thumbs-slide-height: 9rem; */\n  margin-top: var(--thumbs-slide-spacing);\n}\n\n@media screen and (max-width: 40em) {\n  /* .innerContainerWithTopCaption {\n    position: relative;\n  } */\n\n\n  .imgTitleContainer {\n    /* position: absolute;\n    top: 12%; */\n  }\n\n  .slideshowImg {\n    height: 100vh;\n  }\n}\n\n@media screen and (max-width: 53em) {\n  .fullScreenSlideshowImg {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n}\n\n@media screen and (max-width: 44em) and (min-width: 30em) {\n  /* .innerContainerWithTopCaption {\n    position: relative;\n  } */\n  .thumbnailsOuterContainer {\n    bottom: 11%;\n  }\n\n  .thumbnailsAndCaption {\n    bottom: 4%;\n  }\n  \n  .imgTitleContainer {\n    /* position: absolute;\n    top: 5%; */\n  }\n}\n\n@media screen and (max-width: 46em) and (min-width: 30em) {\n  /* .innerContainerWithTopCaption {\n    position: relative;\n  } */\n\n  /* .imgTitleContainer {\n    position: absolute;\n    top: 7%;\n  } */\n}\n\n@media screen and (max-width: 49em) and (min-width: 45em) {\n  /* .innerContainerWithTopCaption {\n    position: relative;\n  } */\n\n\n  /* .imgTitleContainer {\n    position: absolute;\n    top: 5%;\n  } */\n}\n\n@media screen and (max-width: 29em) {\n  .fullScreenContainer img {\n    object-fit: cover;\n  }\n\n  .emblaThumbs {\n    --thumbs-slide-spacing: 3px; \n    /* --thumbs-slide-height: 9rem; */\n    margin-top: var(--thumbs-slide-spacing);\n  }\n\n\n\n  .htmlVideo {\n    margin-top: 5vh;\n  }\n\n  .thumbnails {\n    width: 98%;\n  }\n\n  .thumbnail {\n    width: 80px;\n    max-width: 80px;\n  }\n\n  .htmlVideoOuterContainer video {\n    max-height: 65vh;\n  }\n\n  .videoIconsHeader {\n    position: fixed;\n    top: 2%;\n    right: 15px;\n  }\n\n  .videoOuterContainer {\n    width: 88%;\n    margin-left: auto;\n    margin-right: auto;\n    height: 100%;\n    max-height: 65vh;\n  }\n\n  .htmlVideoOuterContainer {\n    width: 94%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .iconsHeader {\n    position: fixed;\n    left: 115px;\n  }\n\n  .slideshowInnerVideoContainer {\n    top: 3%;\n  }\n\n  .next1,\n  .prev1 {\n    padding-bottom: 2vh;\n    padding-top: 2vh;\n  }\n\n  .next1 {\n    padding-left: 4vw;\n  }\n\n  .prev1 {\n    padding-right: 4vw;\n  }\n\n  .iconsHeader {\n    /* font-size: 28px; */\n  }\n\n}\n\n@media screen and (max-width: 53em) {\n  .slideshowImg {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 100vw;\n    height: 70vh;\n  }\n\n  .slideshowImg img {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .slideshowInnerContainerFullScreen {\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    transition: top 0.2s ease-in-out 0s;\n    top: 10%;\n    align-content: center;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    z-index: 1000000;\n  }\n\n  .containImg {\n    object-fit: contain;\n  }\n}\n\n.fullScreenContainer img {\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n}\n\n.thumbnails {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.reactTransformComponent {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.magnifierImage {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* CSS loader  */\n.loader {\n  width: 44px;\n  height: 44px;\n  box-sizing: border-box;\n\n  border-radius: 50%;\n\n  display: inline-block;\n  position: fixed;\n  top: 35%;\n  left: 50%;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.dayLoader {\n  border: 5px solid #626b77;\n  border-bottom-color: transparent;\n}\n\n.nightLoader {\n  border: 5px solid #fff;\n  border-bottom-color: transparent;\n}\n\n.lightboxImg {\n  max-height: 70vh;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.controls button, .closeButton, .closeButtonRounded {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.controls svg {\n  box-sizing: border-box;\n}\n\n.closeButton svg, .closeButtonRounded svg {\n  box-sizing: border-box;\n  font-size: 16px;\n  padding-top: 0.5px;\n}\n\n.closeButton {\n  padding-top: 3px;\n}\n\n.closeButtonRounded {\n  cursor: pointer;\n\n}\n\n.closeButtonRounded svg {\n  margin: 0;\n  padding: 5px;\n  background-color: black;\n  border-color: transparent;\n  border-radius: 28px;\n\n}\n\n.thumbnailsAndCaption {\n  height: 19vh;\n  margin-top: 0em;\n  width: 100vw;\n}\n\n.thumbnailsWithCaption {\n  margin-top: 0em;\n}\n\n.slideImageAndCaption {\n  top: 9%;\n}\n\n.slideImageAndCaption.hideControlsBar {\n  top: 0;\n}\n\n.slideshowAnimContainer {\n  -ms-overflow-style: none;\n  /* scrollbar-width: none;   */\n}\n.thumbnails::-webkit-scrollbar {\n  display: none;\n}\n\n.roundedBorder {\n  border-radius: 20px;\n}\n\n.maxWidthFull {\n  max-width: 100%;\n}\n\n.maxWidthWithoutMagnifier {\n  max-width: 80%;\n}\n\n@media screen and (max-width: 880px) {\n  .iconsHeader {\n    position: fixed;\n    right: 5%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .iconsHeader {\n    position: fixed;\n    left: 180px;\n  }\n  \n}\n\n@media screen and (max-width: 440px) {\n  .iconsHeader {\n    position: fixed;\n    left: 160px;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  .iconsHeader {\n    position: fixed;\n    left: 140px;\n  }\n}\n\n@media screen and (max-width: 385px) {\n  .iconsHeader {\n    position: fixed;\n    left: 135px;\n    /* top: 24px; */\n  }\n}\n\n@media screen and (max-width: 365px) {\n  .iconsHeader {\n    position: fixed;\n    left: 90px;\n  }\n}\n\n@media screen and (max-width: 345px) {\n  .iconsHeader {\n    position: fixed;\n    left: 82px;\n  }\n}\n\n@media screen and (max-width: 325px) {\n  .iconsHeader {\n    position: fixed;\n    left: 60px;\n  }\n}\n\n@media screen and (max-width: 300px) {\n  .iconsHeader {\n    position: fixed;\n    left: 30px;\n  }\n}\n\n.lightboxVideo {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.navigation-wrapper {\n  position: relative;\n}\n\n.dots {\n  display: flex;\n  padding: 10px 0;\n  justify-content: center;\n}\n\n.dot {\n  border: none;\n  width: 10px;\n  height: 10px;\n  background: #c5c5c5;\n  border-radius: 50%;\n  margin: 0 5px;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.dot:focus {\n  outline: none;\n}\n\n.dot.active {\n  background: #000;\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  transition: all 0.2s;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  color: #fff;\n  cursor: pointer;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-family: sans-serif;\n}\n\n.leftArrow {\n  left: 8px;\n  padding-right: 10px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n.rightArrow {\n  left: auto;\n  right: 8px;\n  padding-left: 10px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n.arrow:hover {\n  color: rgb(230, 230, 230);\n}\n\n.arrow--disabled,\n.arrow--disabled:hover {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navDotsMargin {\n  margin-top: 12px;\n}\n\n.inactiveThumbnailBorderImgSlider {\n  border: 'solid transparent 2px';\n}\n\n.ytVideoImgSlider {\n  width: 100%;\n  height: 100%;\n}\n\n.ytVideoImgSlider iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.outerYTVideoImgSlider {\n  height: 100%;\n}\n\n.lightboxjs iframe {\n  margin: none;\n  padding: none;\n  border: none;\n}\n\n.imgSliderArrow {\n  z-index: 100000;\n  background-color: transparent;\n  border: none;\n}\n\n.thumbnails {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.lightboxjsIcon > * { color: inherit; fill: inherit }\n\n.embla {\n  margin-left: auto;\n  margin-right: auto;\n  --slide-spacing: 1rem;\n  --slide-size: 100%;\n  --slide-height: 19rem;\n}\n\n.emblaViewport {\n  overflow: hidden;\n  width: 100vw;\n}\n\n.emblaContainer {\n  backface-visibility: hidden; \n  touch-action: pan-y;\n  height: auto;\n  margin-left: calc(var(--slide-spacing) * -1);\n  display: grid;  \n  grid-auto-flow: column;  \n  grid-auto-columns: 100%; \n  max-width: 100vw;\n  margin-left: auto;\n  margin-right: auto; \n  /* width: 80%;\n*/\n}\n\n.emblaContainerImgMetadata {\n  width: 78vw;\n  max-width: 78vw;\n  height: 80vh;\n}\n\n.imgdrag .emblaSlide {\n  flex: 0 0 80%;\n  min-width: 0;\n  max-width: 100%;\n  padding-left: 12px;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.emblaThumbsViewport {\n  overflow: hidden;\n}\n\n.emblaThumbsContainer {\n  display: flex;\n  flex-direction: row;\n  margin-left: calc(var(--thumbs-slide-spacing) * -1);\n  width: 100%;\n  /* align-items: center;\n  text-align: center;\n  width: fit-content; */\n  /* justify-content: center; */\n  \n}\n\n.emblaThumbsContainer::before, .emblaThumbsContainer::after {\n  content: '';  /* Insert pseudo-element */\n  margin: auto; /* Make it push flex items to the center */\n}\n\n\n.emblaThumbsSlide {\n  /* min-width: 0; */\n  padding-left: var(--thumbs-slide-spacing);\n  /* position: relative; */\n  /* width: 140px; */\n}\n\n.emblaThumbsSlideImg {\n  /* display: block; */\n  height: var(--thumbs-slide-height);\n  width: 100%;\n  object-fit: cover;\n}\n\n.mlAuto {\n  margin-left: auto;\n}\n\n.metadata {\n  color: white;\n}\n\n.emblaSlideGrid {\n  display: flex;\n}\n\n.metadata {\n  text-align: left;\n  min-width: 17vw;\n  max-width: 17vw;\n  padding-top: 5vw;\n}\n\n.metadataPanel {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n\n.metadataInnerContainer {\n  padding-left: 7vw;\n}\n\n.metadataInnerContainer span {\n  display: block;\n}\n\n\n.imgMetadataCloseBtn {\n  position: absolute;\n  top: 1%;\n  right: 2%;\n  background: none;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n/* Styling from react-zoom-pan-pinch library */\n.reactTransformWrapper {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n\n.reactTransformComponent {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n\n.reactTransformComponent img {\n  pointer-events: none;\n}\n\n.navigationDot {\n  height: 10px;\n  width: 10px;\n  background-color: silver;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n}\n\n.navigationDotContainer {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.imgfade.emblaContainer {\n  transform: none !important; /* override Embla */\n  display: flex;\n  /* height: 250px; */\n}\n\n.notFullScreen {\n  top: 0;\n}\n\n.imgfade.emblaSlide {\n  flex: 0 0 auto;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  /* top: 0; */\n  left: 0 !important; /* override Embla */\n  right: 0 !important; /* override Embla */\n  opacity: 0;\n  transition: opacity 0.5s;\n  counter-increment: embla;\n  border-radius: 0.5rem;\n}\n\n.imgFadeWithTopCaption {\n  top: 16%;\n  position: fixed;\n}\n\n.imgfade.emblaSlideSelected {\n  opacity: 1;\n  transition: opacity 0.3s;\n  z-index: 1;\n}\n\n.imgfade.emblaSlide:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.fullImg {\n  height: 84vh;\n  max-height: 84vh;\n  object-fit: contain;\n}\n\n.rotateImg90Deg{\ntransform: rotate(90deg);\ntransition: transform 1s linear;\n}  \n\n.rotate_img {\ntransition: transform 0.7s linear;\n}\n\n.fullScreenContainer img {\n/* max-height: 100vh; */\n}\n\n.slideshowImg img {\nheight: 100%;\n}\n\n.tab.react-tabs__tab--selected {\n    background: #fe7b05;\n    border: wheat;\n    color: white;\n}\n.tabslist .tab {\n    width: 132px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n}\n\n:focus-visible {\n  outline: none !important;\n}\n\n/* STYLE H */\n\n.checkbox.style-h {\n\tdisplay: block;\n\tposition: relative;\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tmargin-bottom: 0 !important;\n\t\n  }\n  .checkbox.style-h input {\n\tposition: absolute;\n\topacity: 0;\n\tcursor: pointer;\n\theight: 0;\n\twidth: 0;\n  }\n  .checkbox.style-h input:checked ~ .checkbox__checkmark {\n\tbackground-color: #ca8a04 !important;\n  }\n  .checkbox.style-h input:checked ~ .checkbox__checkmark:after {\n\topacity: 1;\n\ttop: 0px;\n  }\n  .checkbox.style-h input:checked ~ .checkbox__body {\n\tbackground-position: 0 0;\n\tcolor: #fff;\n  }\n  .checkbox.style-h:hover input ~ .checkbox__checkmark {\n\tbackground-color: #343f6d;\n  }\n  .checkbox.style-h:hover input:checked ~ .checkbox__checkmark {\n\tbackground-color: #343f6d;\n  }\n  /* .checkbox.style-h:hover .checkbox__body {\n\tbox-shadow: 5px 5px 10px rgba(0,0,0,0.2);\n  } */\n  .checkbox.style-h .checkbox__checkmark {\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tleft: 15px;\n\theight: 20px;\n\twidth: 20px;\n\tbackground-color: #343f6d;\n\ttransition: background-color 0.25s ease;\n\tborder-radius: 4px;\n\t/* box-shadow: inset 2px 2px 4px rgba(0,0,0,0.1), inset -2px -2px 4px rgba(255,255,255,0.4); */\n  }\n  .checkbox.style-h .checkbox__checkmark:after {\n    content: \"\";\n    position: absolute;\n    left: 8px;\n    top: -15px;\n    width: 8px;\n    height: 16px;\n    border: solid #fff;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n    opacity: 0;\n    transition: opacity 0.25s ease, top 0.25s ease;\n}\n  /* .checkbox.style-h .checkbox__checkmark:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tleft: 10px;\n\ttop: -15px;\n\twidth: 10px;\n\theight: 20px;\n\tborder: solid #fff;\n\tborder-width: 0 4px 4px 0;\n\ttransform: rotate(45deg);\n\topacity: 0;\n\ttransition: opacity 0.25s ease, top 0.25s ease;\n  } */\n  .checkbox.style-h .checkbox__body {\n\tcolor: #eee;\n\tline-height: 1.4;\n\tfont-size: 13px;\n\ttransition: font-weight 0.25s ease;\n\tfont-weight: bold;\n\t/* color: #333; */\n\t/* background: linear-gradient(45deg, #08121c 0%, #08121c 50%, #08121c 50%, #0f1a25 100%); */\n\tbackground-size: 200% 100%;\n\tbackground-position: 100% 0;\n\tpadding: 6px 15px;\n\tpadding-left: 52px;\n\tborder-radius: 10px;\n\t/* box-shadow: 2px 2px 5px rgba(0,0,0,0.2); */\n\ttransition:  background 1s ease, color 0.25s ease;\n\ttext-align: left;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
